/* eslint-disable no-nested-ternary */
import React, { createRef, Fragment, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import DimpleDivider from '@tds/core-dimple-divider';
import Modal from '@tds/community-modal';
import Button from '@tds/core-button';
import _ from 'lodash';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import request, {
  isAdmin,
  isOrderFulfillmentTeam,
  isProposalHouse,
  isSalesManager,
  isSalesRep
} from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import { ProgressBar, StatusBar } from '../design';
import FormField from './formField';
import {
  normalizedFields,
  calcFieldMonthlyPayment,
  getMultiCheckboxOptions,
  findField,
  getFieldName,
  getFieldValue,
  getFieldType,
  getFieldChecked,
  checkBusinessConnectEdition
} from './utils/formCommon';

import {
  GroupTitle,
  GroupWrapper,
  GroupWrapperStyled,
  SummaryGroupWrapper
} from './css';
import { Box } from '../design/css';

import {
  orderStatus,
  businessConnectQuoteToolForm,
  contentFulFields,
  fieldAddDevices,
  fieldAdditionalGSuiteBusinessLicences,
  fieldAdditionalTollFreeMinutePacks,
  fieldAdditionalTollFreeNumbers,
  fieldAdditionalTollFreeNumbersNumber,
  fieldAddSpareDevices,
  fieldBAN,
  fieldBusinessConnectEdition,
  fieldBusinessConnectEditionWorkplace,
  fieldBusinessIncorporationNumber,
  fieldBusinessType,
  fieldContractStartDate,
  fieldContractTerm,
  fieldCustomerInformation,
  fieldCustomerSegment,
  fieldDateOfBirth,
  fieldDoesCustomerRequirePrimaryIpDeskPhones,
  fieldDoesCustomerRequireSpareDevices,
  fieldDoesTheCustomerHaveADomainAlready,
  fieldDoesTheCustomerRequireSmartHub,
  fieldDoesTheCustomerRequireWhiteGlove,
  fieldDomainToBeAssociatedWithGSuiteAccount,
  fieldDriversLicenseExpiry,
  fieldDriversLicenseNumber,
  fieldeContractNumber,
  fieldExistingBusinessConnectBANNumber,
  fieldGSuiteBasicLicences,
  fieldGSuiteEmailMigrationServices,
  fieldGSuiteEmailMigrationServicesPaymentType,
  fieldGSuiteInstallAndSetup,
  fieldHowCustomerWantToPayForWhiteGlove,
  fieldIncorporationDate,
  fieldInternetOffer,
  fieldIsThisAnExistingGSuiteCustomer,
  fieldLegalBusinessNameBusinessPersonal,
  fieldLegalBusinessNameBusinessRegular,
  fieldNumberOfSeatsThatRequireWhiteGlove,
  fieldNumberOfTollFreeMinutes,
  fieldOfferConfiguration,
  fieldOfficeSeats,
  fieldOperatingAs,
  fieldOptOutFromGSuiteBusinessLicenses,
  fieldPin,
  fieldPlan,
  fieldStarterSeat,
  fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
  fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
  fieldTelusBusinessConnectLargeMeetings500NumberOfLicences,
  fieldTelusBusinessConnectLiveReportsNumberOfLicences,
  fieldTelusBusinessConnectRoomConnectorNumberOfLicences,
  fieldTelusBusinessConnectRoomsNumberOfLicences,
  fieldTypeOfInstallation,
  fieldVbpRequired,
  fieldVbpTerm,
  fieldVpbStarterSeatRate,
  fieldWhoIsTheExistingInternetProvider,
  fieldWhoIsTheExistingInternetProviderForOtherState,
  groupBusinessConnectImplementation,
  groupDirectoryListing,
  groupVbpOptions,
  keyChannelId,
  keyDevices,
  keyDirectoryListing,
  keyDirectoryListingDetails,
  keyDirectoryListingType,
  keyFeatures,
  keyGSuiteBusinessLicences,
  keyGSuiteComplimentarySeats,
  keyGSuiteEligible,
  keyOfficeSeatRateStandard,
  keyPrimaryDirectoryListingType,
  keySpareDevices,
  keyStarterSeatRateStandard,
  keyWhiteGloveLocations,
  keyDevicesWereChanged,
  paymentTypeEasyPayment,
  paymentTypeUpfront,
  priceSeatsWhiteGloveEasyPayment,
  priceSeatsWhiteGloveUpfront,
  priceSitesWhiteGloveFee,
  quoteStatus,
  sectionAdditionalFeatures,
  sectionGSuiteDetails,
  fieldIsThisOrderForAMobileOrVoiceEdition,
  fieldOtherTelusServices,
  fieldIsThisOrderAPartOfTELUSWorkplace,
  fieldAvailableDiscountsAndPromotions,
  fieldMultisiteOrder,
  fieldMsftDirectRouting,
  fieldDirectoryListing,
  fieldDoesTheCustomerHaveAnExistingInternetConnection,
  fieldVpbOfficeSeatRate,
  orderDetailsForm,
  fieldEmailSigningAuthority,
  fieldEeEnterEmailSigningAuthority,
  fieldPhoneNumberAdministratorContact,
  fieldNumberOfSitesThatRequireWhiteGlove,
  fieldProvinceOfTheOrder,
  fieldDealerNote,
  fieldUploadCustomerReadinessChecklist,
  fieldPostalCodeServiceAddress,
  fieldRsi,
  fieldRsiLicenses,
  fieldAdditionalRsiOptions,
  fieldGenesisLicenses,
  keyAdditionalRsiOptions,
  keyOutlet,
  fieldYesToAllAdvisories,
  fieldRouterPaymentOption,
  fieldCoperToFibreMigration,
  field5UnlimitedLongDistanceCanUs,
  field10UnlimitedLongDistanceCanUs,
  fieldc2fMigrationSeatPrices,
  fieldBusinessConnectImplementationTollFreeNumber,
  fieldC2fAutomatedActivation,
  fieldIsSrtTeamMember,
  sectionSalesRepInfo,
  sectionNetworkPrequalification
} from '../utils/constant';
import {
  promoDeviceRate,
  hwcPromoDeviceRates,
  rsiLicencesRate,
  genesisLicencesRate
} from '../utils/rates';
import { isChannelBSEorBSW } from './formSpecificLogic';
import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import FormSummaryGroup from './formSummaryGroup';
import RepeatedForm from './repeatedForm';
import SeatDetailsForm from './seatDetailsForm';
import FormButtons from './formButtons';
import FormButtonsMultisite from './formButtonsMultiSite';
import stringInterpolation from '../utils/stringInterpolation';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const seatDetailsFormKey = 'seatDetailsForm';
const requiredValue = 'required';
const profile = request.getProfile();

const FormStep = ({
  stepData,
  steps,
  step,
  updateStep,
  setEligible,
  eligible: prequalEligibility,
  history,
  onFormSubmit,
  onSaveAndExit,
  onSave,
  onViewPdf,
  sendToSRT,
  submitForApproval,
  orderData,
  hideProgressBar,
  setOrderData,
  formName,
  prevStep,
  showFormButtons,
  currentSite,
  isMultisiteOrder,
  totalNumberOfMultisites
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { internetOfferTelus, internetOfferOther },
    sendFoApprovalModal,
    sendToSRTModal,
    contentfulValues: {
      yes,
      no,
      valueAlberta,
      valueBritishColumbia,
      mobile,
      valueNew,
      valueAddon,
      valueNinetyNineCentDevicePromo,
      valueCrossSellCredit,
      valueHardwareCreditPromo,
      valueThreeMonthsFree,
      valueMppPromo,
      valueEnhancedPromoAvailable,
      valueMppEnhancedPromoAvailable,
      valueCbmEnhancedPromoAvailable,
      valueInstallationCoTurndownPromo,
      valueBusinessHeroPromo,
      valueVoicePlusPromo,
      valueEasyPayment,
      valuePaymentUpfront,
      businessRegular,
      businessPersonal,
      telusCopperNew,
      threeYears,
      fiveYears,
      monthToMonth,
      devicePolycomVVX250,
      devicePolycomVVX350,
      deviceCisco7841,
      devicePolycomVVX250Promo,
      deviceCisco7841Promo,
      valueDealerBilledDirect,
      valueSegmentSmb1To30,
      valueSegmentCommercial,
      valueSegmentSmb30To100,
      devicePolycomVVX150,
      devicePolycomVVX150HWC,
      devicePolycomVVX250HWC,
      devicePolycomVVX350HWC,
      deviceYealinkT43U,
      deviceYealinkT43UHWC,
      deviceYealinkT48U,
      deviceYealinkT48UHWC,
      deviceYealinkT33G,
      deviceYealinkT33GOld,
      deviceYealinkT33GHWC,
      deviceYealinkT43UOld,
      deviceYealinkT48UOld,
      editionMapping: { enhanced, complete, voicePlus, voice },
      other
    },
    formButtons: { confirmButtonLabel, cancelButtinLabel, newOrderButtonLabel },
    summaryForm: { summaryLabel },
    formStep: {
      maxDevicesErrorMessage,
      minDevicesErrorMessage,
      minSpareDevicesErrorMessage,
      minValueErrorMessage,
      maxValueErrorMessage,
      maxCombinedErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage,
      maxTotalSeatsMessage,
      maxTotalSeatsLessMessage,
      pinNotStartWithZero,
      pinNotBeRepetitive,
      pinNotBeSequential,
      emailDoenotMatch,
      invalidNumber
    },
    modalForm: { fieldRequiredMessage, cannotProceedMessage },
    quoteForm,
    features: { gSuiteNote, gSuiteNote2, customerRequiresDomainName },
    multisite: { siteLabel, summaryLabel: multisiteSummaryLabel }
  } = localizedStrings;

  // Error messages
  const msgMaxDevices = value =>
    stringInterpolation(maxDevicesErrorMessage, value);
  const msgMinValue = value => stringInterpolation(minValueErrorMessage, value);
  const msgMaxValue = value => stringInterpolation(maxValueErrorMessage, value);
  const msgMaxCombinedValue = value =>
    stringInterpolation(maxCombinedErrorMessage, value);
  const msgMinLength = value =>
    stringInterpolation(minLengthErrorMessage, value);
  const msgMaxLength = value =>
    stringInterpolation(maxLengthErrorMessage, value);

  if (!stepData) return null;
  const {
    fields: { name: formStepName, formStepFields, formSummary, modalForms }
  } = stepData;
  const [isLoading, setIsLoading] = useState(true);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [dueMonthly, setDueMonthly] = useState(0);
  const [fieldsWithValue, setFieldsWithValue] = useState();
  const [rates, setRates] = useState({
    [keyStarterSeatRateStandard]: 0,
    [keyOfficeSeatRateStandard]: 0,
    starterSeat: 0,
    officeSeats: 0
  });
  const [priceSeatsWhiteGlove, setPriceSeatsWhiteGlove] = useState({
    dueNow: 0,
    dueMonthly: 0
  });
  const [isVBP, setIsVBP] = useState(false);
  const [modalData, setModalData] = useState({
    title: '',
    body: '',
    confirmText: confirmButtonLabel,
    cancelText: cancelButtinLabel,
    open: false
  });
  const [priceFeatures, setPriceFeatures] = useState(0);
  const [priceGSuite, setPriceGSuite] = useState({
    price: 0,
    monthlyPayment: 0
  });
  const [isFieldReset, setIsFieldReset] = useState(false);
  const formStepRef = createRef();

  // User roles logic
  const userProfile = request.getProfile();
  const { role_id: roleId, channels } = userProfile;
  const isSendToSRT = roleId === 9;
  const isAdminFlow =
    (isAdmin || isOrderFulfillmentTeam) && formName === orderDetailsForm;
  const isSalesSupport = [11, 12].includes(roleId);
  const isSalesSupportFlow =
    isSalesSupport && formName === businessConnectQuoteToolForm && step === 1;
  const channelId = _.get(userProfile, 'channels[0].id', 0);
  const outledID = _.get(userProfile, 'outlet', 0);
  /** All Indirect Sales channel */
  const isVarAgent =
    roleId === 2 &&
    [72, 73, 74, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88].includes(
      channelId
    );
  const isDealer = channelId === 9;

  const isc2fMigrationFlow =
    _.get(orderData, fieldCoperToFibreMigration, '') === yes;

  // G Suite variables
  const gSuiteMigrateUsersPrice = 400;
  const gSuiteMigrateUsersNowPrice = 100;
  const gSuiteMigrateUsersMonthlyPrice = 10;
  const gSuiteInstallAndSetupPrice = 50;
  const isGSuiteOk = amount => amount > 0 && amount < 10;

  // Seat Rates
  const [ratesStarterSeat, setRatesStarterSeat] = useState();
  const [ratesOfficeSeats, setRatesOfficeSeats] = useState();
  const [cbmPromoPostalCodeList, setCbmPromoPostalCodeList] = useState([]);
  const isLastStep = step === steps.length;
  const isSecondLastStep = step === steps.length - 1;
  const [multiSiteOrderSummaryData, setMultiSiteOrderSummaryData] = useState();

  useEffect(() => {
    const config = {
      ...contentfulFormConfig,
      content_type: 'seatRates'
    };
    getContentfulData(config)
      .then(res => {
        const {
          starterSeatRates,
          officeSeatRates,
          cbmPromoPostalCodeList: postalCodeList
        } = getData(res);
        setRatesStarterSeat(starterSeatRates);
        setRatesOfficeSeats(officeSeatRates);
        setCbmPromoPostalCodeList(postalCodeList);
      })
      .catch(() => {});
  }, []);

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;

    return id === formSection;
  });

  const isFieldInGroup = (data, fieldName, groupName) => {
    let result = false;
    let i = 0;

    while (data && i < data.length && !result) {
      const {
        sys: {
          contentType: {
            sys: { id }
          }
        },
        fields: { name }
      } = data[i];

      if (id === formSection) {
        result = isFieldInGroup(
          data[i].fields.formFields,
          fieldName,
          groupName
        );
      } else if (id === formFieldsGroup && name === groupName) {
        const isFound = data[i].fields.fields.find(
          item => item.fields.name === fieldName
        );
        result = typeof isFound !== 'undefined';
      }
      i += 1;
    }

    return result;
  };

  const maxDevices = fields =>
    Number(getFieldValue(fieldStarterSeat, fields) || 0) +
    Number(getFieldValue(fieldOfficeSeats, fields) || 0);

  const maxTotalDevices = maxDevices(formFields) * 4;

  const gSuiteBusinessLicences = fields => {
    const result = Math.round(maxDevices(fields) * 0.8);
    const maxValue = 500;
    return result > maxValue ? maxValue : result;
  };

  const isFieldGSuiteInstallAndSetupDisabled = fields => {
    const amountX = gSuiteBusinessLicences(fields);
    const amountBusiness = +fields[fieldAdditionalGSuiteBusinessLicences].value;
    const amountBasic = +_.get(fields, 'fieldGSuiteBasicLicences.value', 0);

    return amountX + amountBusiness + amountBasic > 400;
  };

  const isRelatedFieldExisted = (field, fields) => {
    const {
      appearsAfterField,
      appearsAfterValue,
      name,
      backendFieldValidation
    } = field;

    if (
      (getFieldValue(fieldBusinessConnectEdition, fields) === voice ||
        orderData[fieldBusinessConnectEdition] === voice) &&
      _.get(orderData, fieldCoperToFibreMigration, no) === no &&
      [
        (fieldDoesCustomerRequireSpareDevices,
        fieldDirectoryListing,
        groupDirectoryListing,
        groupBusinessConnectImplementation,
        fieldAdditionalTollFreeMinutePacks,
        fieldAdditionalTollFreeNumbers,
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences,
        fieldGSuiteInstallAndSetup,
        fieldGSuiteEmailMigrationServices,
        fieldGSuiteEmailMigrationServicesPaymentType)
      ].includes(name)
    ) {
      return false;
    }

    if (
      name === groupDirectoryListing &&
      _.get(orderData, fieldDirectoryListing, []).length === 0
    ) {
      return false;
    }

    if (name === fieldDirectoryListing && isMultisiteOrder) {
      const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
      const valueStarterSeat = +getFieldValue(fieldStarterSeat, fields) || 0;
      return (
        [valueAlberta, valueBritishColumbia].includes(valueProvince) &&
        valueStarterSeat === 1
      );
    }

    if (
      name === fieldOptOutFromGSuiteBusinessLicenses &&
      maxDevices(fields) < 1
    ) {
      return false;
    }
    if (
      [
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences,
        fieldGSuiteInstallAndSetup,
        fieldGSuiteEmailMigrationServices,
        fieldGSuiteEmailMigrationServicesPaymentType
      ].includes(name) &&
      (maxDevices(fields) < 1 ||
        getFieldChecked(fieldOptOutFromGSuiteBusinessLicenses, fields) === true)
    ) {
      return false;
    }
    if (
      name === fieldDoesTheCustomerHaveADomainAlready &&
      (Number(orderData[fieldStarterSeat]) +
        Number(orderData[fieldOfficeSeats]) <
        1 ||
        orderData[fieldBusinessConnectEdition] === mobile ||
        orderData[fieldOptOutFromGSuiteBusinessLicenses] === true ||
        orderData[fieldContractTerm] === monthToMonth)
    ) {
      return false;
    }
    if (
      name === fieldGSuiteInstallAndSetup &&
      isFieldGSuiteInstallAndSetupDisabled(fields)
    ) {
      return false;
    }
    if (
      name === fieldGSuiteEmailMigrationServicesPaymentType &&
      getFieldValue(fieldGSuiteEmailMigrationServices, fields) < 5
    ) {
      return false;
    }

    // Main flow -------
    if (!appearsAfterField && !backendFieldValidation) return true;
    if (
      getFieldValue(fieldTypeOfInstallation, fields) === valueAddon &&
      getFieldValue(fieldVbpRequired, fields) === yes &&
      isFieldInGroup(formStepFields, name, groupVbpOptions)
    ) {
      if (isAdminFlow || isOrderFulfillmentTeam) {
        if (
          !name.startsWith('vpbOfficeSeatRate') &&
          !name.startsWith('vbpDesiredPrice')
        ) {
          return !(
            name === fieldVpbStarterSeatRate &&
            getFieldValue(fieldBusinessConnectEdition, fields) !== voicePlus
          );
        }
      } else {
        return false;
      }
    }

    let result = true;
    let i = 0;
    if (appearsAfterField) {
      while (i < appearsAfterField.length && result) {
        const relatedFieldName = getFieldName(
          appearsAfterField[i],
          orderData,
          formName,
          yes
        );
        const relatedFieldType = getFieldType(relatedFieldName, fields);
        const relatedFieldValue =
          relatedFieldType === 'Checkbox'
            ? getFieldChecked(relatedFieldName, fields)
            : getFieldValue(relatedFieldName, fields);
        if (relatedFieldName) {
          if (
            fields[relatedFieldName] &&
            fields[relatedFieldName].isVisible &&
            relatedFieldValue
          ) {
            if (appearsAfterValue) {
              let isValueSelected;
              if (_.isArray(relatedFieldValue)) {
                isValueSelected = appearsAfterValue.find(item =>
                  relatedFieldValue.includes(item.fields.value)
                );
              } else {
                isValueSelected = appearsAfterValue.find(
                  item => relatedFieldValue === item.fields.value
                );
              }
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else if (orderData && orderData[relatedFieldName]) {
            if (fields[relatedFieldName]) {
              if (
                (isFormTouched &&
                  orderData[relatedFieldName] === relatedFieldValue) ||
                !isFormTouched
              ) {
                if (appearsAfterValue) {
                  const isValueSelected = appearsAfterValue.find(
                    item => orderData[relatedFieldName] === item.fields.value
                  );
                  result = result && typeof isValueSelected !== 'undefined';
                }
              } else result = false;
            } else if (appearsAfterValue) {
              const isValueSelected = appearsAfterValue.find(
                item => orderData[relatedFieldName] === item.fields.value
              );
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else {
            result = false;
          }
        }
        i += 1;
      }
    }

    if (formName === businessConnectQuoteToolForm && step === 1) {
      const networkCondition = isChannelBSEorBSW(
        fields,
        name,
        no,
        valueSegmentSmb1To30
      );
      if (networkCondition !== undefined) {
        return networkCondition;
      }
    }
    if (backendFieldValidation) {
      let isVisible = result;
      for (let index = 0; index < backendFieldValidation.length; index += 1) {
        const {
          fields: { key, value }
        } = backendFieldValidation[index];
        isVisible =
          isVisible &&
          (value.split('|').includes(orderData[key]) ||
            (value.split('|').includes('undefined') &&
              typeof orderData[key] === 'undefined'));
      }
      return isVisible;
    }

    return result;
  };

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (!isRelatedFieldExisted(section.fields, fields)) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  useEffect(() => {
    if (formStepFields && !isFieldReset) {
      const updatedFields = normalizedFields(
        formStepFields,
        formFields,
        orderData,
        isSalesSupportFlow,
        localizedStrings,
        isVarAgent
      );
      if (orderData && orderData[keyDevices]) {
        updatedFields[keyDevices] = orderData[keyDevices];
      }
      if (orderData && orderData[keySpareDevices]) {
        updatedFields[keySpareDevices] = orderData[keySpareDevices];
      }

      if (
        updatedFields[fieldeContractNumber] &&
        !_.get(orderData, 'assignedToSRT', 0)
      ) {
        updatedFields[fieldeContractNumber].isRequired = false;
      }

      if (
        (!orderData[fieldBAN] ||
          (orderData[fieldBAN] &&
            orderData[fieldBAN] !==
              orderData[fieldExistingBusinessConnectBANNumber])) &&
        orderData[fieldExistingBusinessConnectBANNumber]
      ) {
        const updatedOrderData = {
          ...orderData,
          [fieldBAN]: orderData[fieldExistingBusinessConnectBANNumber]
        };
        setOrderData(updatedOrderData);
      }
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData]);

  const open = sections.reduce((acc, section) => {
    const {
      fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
    } = section;

    if (isPanelInitiallyOpen) {
      acc.push(name);
    } else {
      const isErrors =
        sectionFields &&
        sectionFields.find(item => {
          const {
            fields: { name: itemName }
          } = item;
          return formErrors[itemName];
        });
      if (typeof isErrors !== 'undefined') acc.push(name);
    }

    return acc;
  }, []);

  const sectionIsVisible = name => {
    /** Hiding Prequalification section for rolw Order fulfillment */
    if (
      (isOrderFulfillmentTeam || isProposalHouse || isSalesManager) &&
      name === sectionNetworkPrequalification
    )
      return false;

    /** Hiding Sales Rep Info for Admin and Sales Rep */
    if (
      (isAdmin || isSalesRep || (isSalesSupport && channels.length === 1)) &&
      name === sectionSalesRepInfo
    )
      return false;

    if (
      name === sectionGSuiteDetails &&
      Number(orderData[fieldStarterSeat]) +
        Number(orderData[fieldOfficeSeats]) <
        1
    ) {
      return false;
    }

    /**
     * Edge Case: Hide Additional features section
     * when the following condition is satisfied
     */

    if (
      name === sectionAdditionalFeatures &&
      getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon &&
      [voice, mobile].includes(
        getFieldValue(fieldBusinessConnectEdition, formFields)
      ) &&
      getFieldValue(fieldStarterSeat, formFields) !== '1'
    ) {
      return false;
    }

    return (
      typeof sections.find(item => item.fields.name === name) !== 'undefined'
    );
  };

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required
    );
    const filteredData = formValues.filter(formValue => {
      const filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }) => !formValue[formKeyValue]
      );
      return filteredValues.length > 0;
    });
    return filteredData;
  };

  const currentDevices =
    (formFields[keyDevices] &&
      formFields[keyDevices].reduce((acc, item) => item.quantity + acc, 0)) ||
    0;

  const currentSpareDevices =
    (formFields[keySpareDevices] &&
      formFields[keySpareDevices].reduce(
        (acc, item) => item.quantity + acc,
        0
      )) ||
    0;

  const currentTotalDevices = currentDevices + currentSpareDevices;

  const sectionFeatures = sections.find(
    item => item.fields.name === sectionAdditionalFeatures
  );

  const isFieldInFeatures = name => {
    if (
      !sectionFeatures ||
      [
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences
      ].includes(name)
    )
      return false;

    const {
      fields: { formFields: featuresFields }
    } = sectionFeatures;
    const result = featuresFields.find(item => {
      const {
        fields: { name: featureName }
      } = item;

      return name === featureName;
    });

    return typeof result !== 'undefined';
  };

  const getFeatures = fields => {
    const features = [];

    if (!sectionFeatures) return null;

    const {
      fields: { formFields: featuresFields }
    } = sectionFeatures;
    featuresFields.forEach(item => {
      const {
        fields: {
          type,
          name: featureName,
          label,
          monthlyPayment: featurePrice,
          options
        }
      } = item;
      let feature;
      if (type === 'Checkbox') {
        if (
          getFieldChecked(featureName, fields) &&
          fields[featureName] &&
          fields[featureName].isVisible
        ) {
          const quantityField = featuresFields.find(field => {
            const {
              fields: { appearsAfterField }
            } = field;
            if (appearsAfterField) {
              const isFeatureFound = appearsAfterField.find(
                i => i.fields.name === featureName
              );
              return typeof isFeatureFound !== 'undefined';
            }
            return false;
          });
          let quantity =
            typeof quantityField !== 'undefined'
              ? Number(
                  getFieldValue(
                    getFieldName(quantityField, orderData, formName, yes),
                    fields
                  )
                )
              : 1;
          if (Number.isNaN(Number(quantity))) quantity = 0;
          const unitPrice = Number.isNaN(Number(featurePrice))
            ? 0
            : featurePrice;
          feature = {
            category: '',
            unitPrice,
            name: featureName,
            description: label,
            monthlyCharges: unitPrice,
            oneTimeCharges: '',
            quantity
          };
        }
      } else if (type === 'MultiCheckbox') {
        const fieldValue = getFieldValue(featureName, fields) || [];
        if (fieldValue.length > 0) {
          fieldValue.forEach(featureItem => {
            const itemDetails = options.filter(
              optionItem =>
                _.get(optionItem, 'fields.value', '') === featureItem
            );
            const unitPrice =
              _.get(itemDetails, '[0].fields.monthlyPayment', 0) ||
              _.get(itemDetails, '[0].fields.price', 0);

            features.push({
              category:
                featureName === fieldAdditionalRsiOptions
                  ? keyAdditionalRsiOptions
                  : keyDirectoryListing,
              unitPrice,
              name: featureName,
              description: featureItem,
              monthlyCharges: _.get(
                itemDetails,
                '[0].fields.monthlyPayment',
                0
              ),
              oneTimeCharges: _.get(itemDetails, '[0].fields.price', 0),
              quantity: 1
            });
          });
        }
      } else if (featureName === fieldRsiLicenses) {
        const valueRsiLicenses = getFieldValue(fieldRsiLicenses, fields);
        if (valueRsiLicenses) {
          features.push({
            category: 'RSI',
            unitPrice: rsiLicencesRate[valueRsiLicenses],
            name: featureName,
            description: `Shadow A1 - ${valueRsiLicenses}`,
            monthlyCharges: rsiLicencesRate[valueRsiLicenses],
            oneTimeCharges: '',
            quantity: 1
          });
        }
        /**
         * Adding a One-Time fee depending on the number of licenses
         */
        if (valueRsiLicenses && +valueRsiLicenses <= 250) {
          features.push({
            category: 'RSI',
            unitPrice: 250,
            name: featureName,
            description: `Shadow A1 Implementation Fee`,
            monthlyCharges: '',
            oneTimeCharges: 250,
            quantity: 1
          });
        }
        if (valueRsiLicenses && +valueRsiLicenses > 250) {
          features.push({
            category: 'RSI',
            unitPrice: 400,
            name: featureName,
            description: `Shadow A1 Implementation Fee - large account`,
            monthlyCharges: '',
            oneTimeCharges: 400,
            quantity: 1
          });
        }
      } else if (featureName === fieldGenesisLicenses) {
        const valueGenesisLicenses = getFieldValue(
          fieldGenesisLicenses,
          fields
        );
        if (valueGenesisLicenses) {
          features.push({
            category: 'Genesis',
            unitPrice: genesisLicencesRate[valueGenesisLicenses],
            name: featureName,
            description: `Genesis - GenAlert 911 - ${valueGenesisLicenses} licenses`,
            monthlyCharges: genesisLicencesRate[valueGenesisLicenses],
            oneTimeCharges: '',
            quantity: 1
          });
        }
      } else if (['Select', 'Radio'].includes(type)) {
        if (fields && fields[featureName] && fields[featureName].isVisible) {
          const { monthlyPayment: optionPrice, value } = fields[featureName];
          let unitPrice = Number.isNaN(Number(optionPrice)) ? 0 : optionPrice;

          // Define the unit price
          if (!unitPrice && orderData && orderData[keyFeatures]) {
            const orderDataValue = orderData[keyFeatures].find(
              i => i.name === featureName
            );
            if (typeof orderDataValue !== 'undefined') {
              const { unitPrice: price } = orderDataValue;
              unitPrice = price;
            }
          }

          // Define the description
          const category = [
            keyDirectoryListingType,
            keyPrimaryDirectoryListingType
          ].includes(featureName)
            ? keyDirectoryListing
            : '';
          const capitalizeFirstLetter = str => {
            return str && str.charAt(0).toUpperCase() + str.slice(1);
          };
          let description = `${quoteForm[featureName] || label}: ${value}`;
          if (
            [
              keyDirectoryListingType,
              keyPrimaryDirectoryListingType,
              fieldNumberOfTollFreeMinutes
            ].includes(featureName)
          ) {
            description = capitalizeFirstLetter(value) || category;
          }

          feature = {
            category,
            unitPrice,
            name: featureName,
            description,
            monthlyCharges: unitPrice,
            oneTimeCharges: '',
            quantity: 1
          };
        }
      }
      if (
        (feature && feature.unitPrice && feature.quantity) ||
        (feature &&
          [
            keyDirectoryListingType,
            fieldMsftDirectRouting,
            field5UnlimitedLongDistanceCanUs,
            field10UnlimitedLongDistanceCanUs
          ].includes(featureName))
      ) {
        features.push(feature);
      }
    });

    return features;
  };

  // Calculation for features - their prices are for Monthly
  const updateFeaturesPrices = features => {
    if (!features) return { monthly: 0, oneTime: 0 };
    return (
      features &&
      features.reduce(
        (acc, item) => {
          const price = Number.isNaN(Number(item.unitPrice))
            ? 0
            : item.unitPrice;
          const quantity = +item.quantity;
          if (item.monthlyCharges) acc.monthly += price * quantity;
          if (item.oneTimeCharges) acc.oneTime += price * quantity;
          return acc;
        },
        { monthly: 0, oneTime: 0 }
      )
    );
  };

  const isGSuiteEnabled = fields => {
    return (
      orderData.isThisAnExistingGSuiteCustomer === no &&
      maxDevices(fields) > 0 &&
      !['', monthToMonth].includes(getFieldValue(fieldContractTerm, fields)) &&
      !['', mobile].includes(
        getFieldValue(fieldBusinessConnectEdition, fields)
      ) &&
      !fields[fieldOptOutFromGSuiteBusinessLicenses].checked
    );
  };

  const getGSuitePrice = fields => {
    const result = {
      price: 0,
      monthlyPayment: 0
    };

    if (!isGSuiteEnabled(fields)) return result;

    // G Suite Licences
    const qtyBusinessLicences =
      +getFieldValue(fieldAdditionalGSuiteBusinessLicences, fields) || 0;
    const qtyBasicLicences = +_.get(
      fields,
      `${fieldGSuiteBasicLicences}.value`,
      0
    );
    const priceBusinessLicences = +fields[fieldAdditionalGSuiteBusinessLicences]
      .monthlyPayment;
    const priceBasicLicences = +_.get(
      fields,
      `${fieldGSuiteBasicLicences}.monthlyPayment`,
      0
    );

    result.monthlyPayment +=
      priceBusinessLicences * qtyBusinessLicences +
      priceBasicLicences * qtyBasicLicences;

    // G Suite Install & Setup
    const totalLicences =
      qtyBusinessLicences + qtyBasicLicences + gSuiteBusinessLicences(fields);
    if (
      fields[fieldGSuiteInstallAndSetup].value === yes &&
      !isFieldGSuiteInstallAndSetupDisabled(fields) &&
      isGSuiteOk(totalLicences)
    ) {
      result.price += gSuiteInstallAndSetupPrice;
    }

    // G Suite Email Migration Service
    const numberOfUsers = +fields[fieldGSuiteEmailMigrationServices].value;
    const paymentType =
      fields[fieldGSuiteEmailMigrationServicesPaymentType].value;
    if (numberOfUsers > 0 && numberOfUsers < 5) {
      result.price += gSuiteMigrateUsersPrice;
    } else if (numberOfUsers > 4 && paymentType) {
      if (paymentType === valuePaymentUpfront) {
        result.price += numberOfUsers * gSuiteMigrateUsersNowPrice;
      } else {
        result.monthlyPayment += numberOfUsers * gSuiteMigrateUsersMonthlyPrice;
      }
    }

    return result;
  };

  const isReadinessChecklistAvailable = () => {
    const valueInstallationType = _.get(orderData, fieldTypeOfInstallation, '');
    const isWgRequired =
      _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') === yes;
    const isStarterSeatPorting =
      orderData.starterSeatDetails &&
      orderData.starterSeatDetails.some(
        val => val.willTheLocalPhoneNumberBePortedIn === yes
      );
    const isOfficeSeatPorting =
      orderData.officeSeatDetails &&
      orderData.officeSeatDetails.some(
        val => val.willTheLocalPhoneNumberBePortedIn === yes
      );
    return (
      isDealer &&
      valueInstallationType === valueNew &&
      (isWgRequired || isStarterSeatPorting || isOfficeSeatPorting)
    );
  };

  const isAdditionalRsiOptionsAvailable = () => {
    const isRsiChecked = getFieldChecked(fieldRsi, formFields);
    const valueRsiLicenses = getFieldValue(fieldRsiLicenses, formFields);
    return isRsiChecked && valueRsiLicenses;
  };

  const getErrors = (data, errors) => {
    let result = errors;

    if (!data) return result;

    delete result[fieldPin];
    delete result[fieldAddDevices];
    delete result[fieldAddSpareDevices];

    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { ineligible } = fields;
      const key = fields.name;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength,
        type,
        checked
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];

      if (id === formFieldsGroup && isRelatedFieldExisted(fields, formFields)) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired && type !== 'Checkbox') {
          if (!value && isRelatedFieldExisted(fields, formFields)) {
            result[key] = { text: fieldRequiredMessage, ref };
          } else {
            delete result[key];
          }
        }
        if (ineligible) {
          const {
            fields: { value: ineligibleValue }
          } = ineligible;
          const isIneligibleValue = ineligibleValue.split('|').includes(value);
          if (isIneligibleValue) {
            result[key] = { text: cannotProceedMessage, ref };
          }
        }
        if (isRequired && type === 'Checkbox') {
          if (!checked && isRelatedFieldExisted(fields, formFields))
            result[key] = { text: fieldRequiredMessage, ref };
          else delete result[key];
        }

        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = { text: msgMinValue(minValue), ref };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = { text: msgMaxValue(maxValue), ref };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = { text: msgMinLength(minLength), ref };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = { text: msgMaxLength(maxLength), ref };
        }

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(fields, formFields))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = +value < +expectedValue;
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
          }
        }

        // Checking for Admin phone number which should not start with 888, 877,866,855,844,833,800
        if (key === fieldPhoneNumberAdministratorContact) {
          const valueAdminPhoneNumber = getFieldValue(
            fieldPhoneNumberAdministratorContact,
            formFields
          );
          const restrictedNumber = [888, 877, 866, 855, 844, 833, 800];

          if (
            valueAdminPhoneNumber.length < 10 ||
            restrictedNumber.includes(+valueAdminPhoneNumber.slice(0, 3))
          ) {
            result[key] = { text: invalidNumber, ref };
          }
        }

        // Custom checks
        if (
          [
            fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
            fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
            fieldTelusBusinessConnectLargeMeetings500NumberOfLicences
          ].includes(key)
        ) {
          const value1 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
            formFields
          );
          const value2 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
            formFields
          );
          const value3 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings500NumberOfLicences,
            formFields
          );
          const maxSumValue =
            Number(getFieldValue(fieldStarterSeat, formFields)) +
            Number(getFieldValue(fieldOfficeSeats, formFields));

          if (Number(value1) + Number(value2) + Number(value3) > maxSumValue) {
            result[key] = { text: msgMaxCombinedValue(maxSumValue), ref };
          }
        }
        if (key === fieldOfficeSeats) {
          const starterAmount = +getFieldValue(fieldStarterSeat, formFields);
          const officeAmount = +getFieldValue(fieldOfficeSeats, formFields);
          const valueBCE = getFieldValue(
            fieldBusinessConnectEdition,
            formFields
          );
          const valueTOI = getFieldValue(fieldTypeOfInstallation, formFields);

          // Less than 4
          if (
            valueBCE === voice &&
            valueTOI === valueAddon &&
            starterAmount + officeAmount > 4
          )
            result[key] = { text: maxTotalSeatsLessMessage, ref };
          else if (result[key] && result[key].text === maxTotalSeatsLessMessage)
            delete result[key];

          // Greater than 0
          if (starterAmount + officeAmount < 1)
            result[key] = { text: maxTotalSeatsMessage, ref };
          else if (result[key] && result[key].text === maxTotalSeatsMessage)
            delete result[key];
        }

        if (
          key === fieldNumberOfSeatsThatRequireWhiteGlove &&
          getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, formFields) ===
            yes
        ) {
          const maxSumValue =
            Number(getFieldValue(fieldStarterSeat, formFields)) +
            Number(getFieldValue(fieldOfficeSeats, formFields));

          if (parseFloat(value) === 0) {
            result[key] = { text: maxTotalSeatsMessage, ref };
          } else if (parseFloat(value) > maxSumValue) {
            result[key] = { text: msgMaxValue(maxSumValue), ref };
          }
        }
      }

      if (key === fieldUploadCustomerReadinessChecklist) {
        if (
          formFields.uploadCustomerReadinessChecklist.fileUploded ||
          !isReadinessChecklistAvailable()
        ) {
          delete result[key];
        }
      }

      if (
        key === fieldExistingBusinessConnectBANNumber &&
        isMultisiteOrder &&
        currentSite > 1 &&
        !isOrderFulfillmentTeam
      ) {
        delete result[key];
      }

      if (key === fieldIsSrtTeamMember && !isSalesRep) {
        delete result[key];
      }
    });

    /**
     * Condition for Pin number field
     * 1) Must contain between 4 and 6 digits
     * 2) Cannot start with zero
     * 3) Cannot be repetitive (ex. 0000, 1111, 9999)
     * 4) Cannot be sequential (ex. 1234, 5678)
     */
    if (formFields[fieldPin]) {
      const valuePin = getFieldValue(fieldPin, formFields);
      if (!valuePin)
        result[fieldPin] = {
          text: fieldRequiredMessage,
          ref: formFields[fieldPin].ref
        };
      else if (valuePin.indexOf('0') === 0)
        result[fieldPin] = {
          text: pinNotStartWithZero,
          ref: formFields[fieldPin].ref
        };
      else {
        // not be repetitive (ex. 0000, 1111, 9999)
        const isRepetitive = valuePin
          .split('')
          .filter(item => item !== valuePin[0]);
        if (!isRepetitive.length) {
          result[fieldPin] = {
            text: pinNotBeRepetitive,
            ref: formFields[fieldPin].ref
          };
        } else {
          /**
           *
           * Can pass upto 2 sequential ie. (12, 34, 45)
           * Cannot pass more then 2 sequence ie. (123, 4567, 12345, 345678)
           */
          const pinDigits = valuePin.split('').map(item => Number(item));
          let isSequential = true;
          let i = 1;
          while (i < pinDigits.length && isSequential) {
            if (pinDigits[i] - pinDigits[i - 1] !== 1) isSequential = false;
            i += 1;
          }
          if (isSequential) {
            result[fieldPin] = {
              text: pinNotBeSequential,
              ref: formFields[fieldPin].ref
            };
          }
        }
      }
    }

    if (isSalesSupportFlow && _.get(userProfile, 'channels', []).length > 1) {
      if (getFieldValue(keyChannelId, formFields)) {
        delete result[keyChannelId];
      } else {
        result[keyChannelId] = {
          text: fieldRequiredMessage,
          ref: formFields[keyChannelId].ref
        };
      }
    }

    if (isVarAgent && formName === businessConnectQuoteToolForm) {
      if (getFieldValue(keyOutlet, formFields) || outledID) {
        delete result[keyOutlet];
      } else {
        result[keyOutlet] = {
          text: fieldRequiredMessage,
          ref: formFields[keyOutlet].ref
        };
      }

      if (!getFieldValue(keyOutlet, formFields) && outledID) {
        formFields[keyOutlet].value = outledID;
      }
    }

    // Checking if Signing Authority & Re-enter Signing Authority emails are the same
    if (
      getFieldValue(fieldEmailSigningAuthority, formFields) !==
      getFieldValue(fieldEeEnterEmailSigningAuthority, formFields)
    ) {
      result[fieldEmailSigningAuthority] = {
        text: emailDoenotMatch,
        ref: formFields[fieldEeEnterEmailSigningAuthority].ref
      };
    }

    // Checking if proper number of PRIMARY DEVICES are selected
    if (
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, formFields) ===
      yes
    ) {
      if (_.get(formFields, 'devices', []).length === 0) {
        result[fieldAddDevices] = {
          text: minDevicesErrorMessage,
          ref: formFields[fieldAddDevices].ref
        };
      } else if (maxDevices(formFields) < currentDevices) {
        result[fieldAddDevices] = {
          text: msgMaxDevices(maxDevices(formFields)),
          ref: formFields[fieldAddDevices].ref
        };
      }
    }

    // Checking if proper number of SPARE DEVICES are selected
    if (
      getFieldValue(fieldDoesCustomerRequireSpareDevices, formFields) === yes
    ) {
      if (_.get(formFields, 'additionalSpareDevices', []).length === 0) {
        result[fieldAddSpareDevices] = {
          text: minSpareDevicesErrorMessage,
          ref: formFields[fieldAddSpareDevices].ref
        };
      } else if (maxTotalDevices < currentTotalDevices) {
        result[fieldAddSpareDevices] = {
          text: msgMaxDevices(maxTotalDevices),
          ref: formFields[fieldAddSpareDevices].ref
        };
      }
    }

    if (!_.get(orderData, 'assignedToSRT', 0))
      delete result[fieldeContractNumber];

    if (isc2fMigrationFlow) {
      delete result[fieldeContractNumber];
    }
    return result;
  };

  const getFormData = () => {
    const result = Object.keys(formFields)
      .filter(key => typeof formFields[key].value !== 'undefined')
      .reduce((acc, key) => {
        const { type, value: oldValue, checked, isVisible } = formFields[key];
        const value = isVisible ? oldValue : '';

        if (key === fieldBusinessConnectEditionWorkplace && value) {
          acc[fieldBusinessConnectEdition] = value;
        }

        acc[key] = type === 'Checkbox' ? checked : value;
        return acc;
      }, {});

    // Devices
    if (formFields[keyDevices]) {
      const field = findField(formStepFields, fieldAddDevices);
      if (field) {
        if (isRelatedFieldExisted(field.fields, formFields)) {
          result[keyDevices] = formFields[keyDevices];
        } else {
          result[keyDevices] = [];
        }
      } else {
        result[keyDevices] = formFields[keyDevices];
      }
    }
    if (formFields[keySpareDevices]) {
      const field = findField(formStepFields, fieldAddSpareDevices);
      if (field) {
        if (isRelatedFieldExisted(field.fields, formFields)) {
          result[keySpareDevices] = formFields[keySpareDevices];
        } else {
          result[keySpareDevices] = [];
        }
      } else {
        result[keySpareDevices] = formFields[keySpareDevices];
      }
    }
    if (formFields[keyDevicesWereChanged]) {
      const { starterSeatDetails, officeSeatDetails } = contentFulFields;
      result[starterSeatDetails] = [];
      result[officeSeatDetails] = [];
    }

    if (formFields[keyWhiteGloveLocations]) {
      result[keyWhiteGloveLocations] = formFields[keyWhiteGloveLocations];
    }

    if (formFields[keyDirectoryListingDetails]) {
      result[keyDirectoryListingDetails] =
        formFields[keyDirectoryListingDetails];
    }

    if (step === 1) {
      const editionMapping = {
        'Voice +': 'voicePlus',
        Enhanced: 'enhanced',
        Complete: 'complete',
        'Complete +': 'completePlus',
        'Voix PLUS': 'voixPlus',
        Amélioré: 'enhanced',
        Complet: 'complete',
        'Complet PLUS': 'completePlus'
      };
      const fieldBCEvalue =
        formFields.businessConnectEdition &&
        editionMapping[formFields.businessConnectEdition.value];

      // The internetOffer field is always BYOA now
      if (orderData[fieldWhoIsTheExistingInternetProvider] === 'TELUS') {
        result[fieldInternetOffer] = internetOfferTelus;
      } else {
        result[fieldInternetOffer] = internetOfferOther;
      }

      // Reset VBP Starter Seat Rate if VBP == No
      if (result[fieldVbpRequired] === no) {
        result[fieldVpbStarterSeatRate] = '';
      }

      if (formFields[`vpbOfficeSeatRate_${fieldBCEvalue}`]) {
        result.vpbOfficeSeatRate =
          result[fieldVbpRequired] === no
            ? ''
            : formFields[`vpbOfficeSeatRate_${fieldBCEvalue}`].value;
        delete result[`vpbOfficeSeatRate_${fieldBCEvalue}`];
      }

      if (formFields[`vbpDesiredPrice_${fieldBCEvalue}`]) {
        result.vbpDesiredPrice =
          result[fieldVbpRequired] === no
            ? ''
            : formFields[`vbpDesiredPrice_${fieldBCEvalue}`].value;
        delete result[`vbpDesiredPrice_${fieldBCEvalue}`];
      }

      if (
        getFieldValue(fieldBusinessConnectEdition, formFields) === voice &&
        getFieldValue(fieldTypeOfInstallation, formFields) !== valueAddon &&
        maxDevices(formFields) > 5
      ) {
        // For BCON Voice starter and office seats have the same rate
        result.vpbOfficeSeatRate = rates[keyStarterSeatRateStandard];
      }
    }

    // Features
    const features = getFeatures(formFields);
    if (features) {
      result[keyFeatures] = features;
    }

    // Starter and office seats rates standard
    if (rates[keyStarterSeatRateStandard]) {
      result[keyStarterSeatRateStandard] = rates[keyStarterSeatRateStandard];
    }
    if (rates[keyOfficeSeatRateStandard]) {
      result[keyOfficeSeatRateStandard] = rates[keyOfficeSeatRateStandard];
    }

    if (result[fieldWhoIsTheExistingInternetProviderForOtherState]) {
      result[fieldWhoIsTheExistingInternetProvider] =
        result[fieldWhoIsTheExistingInternetProviderForOtherState];
      delete result[fieldWhoIsTheExistingInternetProviderForOtherState];
    }

    if (!isAdditionalRsiOptionsAvailable())
      result[fieldAdditionalRsiOptions] = [];
    // if (!getFieldChecked(fieldRsi, formFields) && result[fieldRsiLicenses])
    //   result[fieldRsiLicenses] = '';
    //  TODO: it need to be removed once reset task is completed.
    if (result[fieldBusinessType] === businessRegular) {
      result[fieldLegalBusinessNameBusinessPersonal] = '';
      result[fieldDriversLicenseNumber] = '';
      result[fieldDriversLicenseExpiry] = '';
      result[fieldDateOfBirth] = '';
    } else if (result[fieldBusinessType] === businessPersonal) {
      result[fieldLegalBusinessNameBusinessRegular] = '';
      result[fieldOperatingAs] = '';
      result[fieldBusinessIncorporationNumber] = '';
      result[fieldIncorporationDate] = '';
    } else if (
      result[fieldInternetOffer] &&
      result[fieldInternetOffer] !== telusCopperNew
    ) {
      result[fieldPlan] = '';
    }

    // GSuite logic
    if (formName === orderDetailsForm && step === 1) {
      if (
        orderData[fieldIsThisAnExistingGSuiteCustomer] === no &&
        result[fieldBusinessConnectEdition] !== mobile &&
        result[fieldBusinessConnectEdition] !== voice &&
        result[fieldContractTerm] !== monthToMonth
      ) {
        const complimentarySeats = gSuiteBusinessLicences(formFields);
        const customerOptOut = getFieldChecked(
          fieldOptOutFromGSuiteBusinessLicenses,
          formFields
        );
        result[keyGSuiteEligible] = true;
        result[keyGSuiteComplimentarySeats] = complimentarySeats;
        result[keyGSuiteBusinessLicences] = !customerOptOut
          ? stringInterpolation(gSuiteNote, complimentarySeats)
          : '';
        if (result[fieldOptOutFromGSuiteBusinessLicenses] === true) {
          result[fieldAdditionalGSuiteBusinessLicences] = '';
          result[fieldGSuiteBasicLicences] = '';
          result[fieldGSuiteInstallAndSetup] = '';
          result[fieldGSuiteEmailMigrationServices] = '';
          result[fieldGSuiteEmailMigrationServicesPaymentType] = '';
        }
      } else {
        result[keyGSuiteEligible] = false;
        result[keyGSuiteComplimentarySeats] = '';
        result[keyGSuiteBusinessLicences] = '';
        result[fieldAdditionalGSuiteBusinessLicences] = '';
        result[fieldGSuiteBasicLicences] = '';
        result[fieldGSuiteInstallAndSetup] = '';
        result[fieldGSuiteEmailMigrationServices] = '';
        result[fieldGSuiteEmailMigrationServicesPaymentType] = '';
      }
    }

    if (result[fieldDoesTheCustomerHaveADomainAlready] === no) {
      result[
        fieldDomainToBeAssociatedWithGSuiteAccount
      ] = customerRequiresDomainName;
    }

    return result;
  };

  // This function is used to determine if VBP approval is required
  const checkVBP = () => {
    const valueOrderType = getFieldValue(fieldTypeOfInstallation, formFields);
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      formFields
    );
    const statusOfQuote = _.get(orderData, 'quoteStatus', '');
    const statusOfOrder = _.get(orderData, 'status', '');
    const valueIsSrtTeamMember = getFieldValue(
      fieldIsSrtTeamMember,
      formFields
    );

    if (statusOfOrder === orderStatus.waitingOnSales) return false;
    const customerRequireVBP = _.get(formFields, 'vbpRequired.value', no);

    if (
      isOrderFulfillmentTeam ||
      isSalesSupport ||
      (isSalesRep && valueIsSrtTeamMember === yes) ||
      valueOrderType === valueAddon
    )
      return false;

    if (customerRequireVBP === yes && statusOfQuote === quoteStatus.approved) {
      const approvedRate = _.get(orderData, fieldVpbOfficeSeatRate);
      const vbpOfficeSeatRateKey = {
        'Voice +': 'vpbOfficeSeatRate_voicePlus',
        Enhanced: 'vpbOfficeSeatRate_enhanced',
        Complete: 'vpbOfficeSeatRate_complete',
        'Complete +': 'vpbOfficeSeatRate_completePlus'
      };
      const currentRate = getFieldValue(
        vbpOfficeSeatRateKey[valueBusinessConnectEdition],
        formFields
      );
      return +approvedRate !== +currentRate;
    }
    return customerRequireVBP === yes;
  };

  const validateForm = e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      const fields = getFormData();
      const vbp = checkVBP();
      const newStatus = vbp
        ? quoteStatus.pendingApproval
        : quoteStatus.approved;

      onSave({ ...fields, quoteStatus: newStatus }).then(() => {
        setIsFormValidated(true);
        setIsVBP(vbp);
      });
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const onSendToSRT = e => {
    e.preventDefault();
    const fields = getFormData();
    sendToSRT({ ...fields }).then(() => {
      setModalData({
        ...modalData,
        title: sendToSRTModal.title,
        body: sendToSRTModal.body,
        confirmText: sendToSRTModal.confirmText,
        cancelText: sendToSRTModal.cancelText,
        open: true
      });
    });
  };

  const onSubmitForApproval = e => {
    e.preventDefault();
    const fields = getFormData();
    submitForApproval({ ...fields }).then(() => {
      setModalData({
        ...modalData,
        title: sendFoApprovalModal.title,
        body: sendFoApprovalModal.body,
        confirmText: sendFoApprovalModal.confirmText,
        cancelText: sendFoApprovalModal.cancelText,
        open: true
      });
    });
  };

  const saveAndExit = () => {
    const fields = getFormData();
    if (Object.entries(fields).length) {
      onSaveAndExit({ ...fields });
    }
  };

  const nextStep = e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      const fields = getFormData();
      if (formName === orderDetailsForm && step === 1) {
        fields.quoteStatus = quoteStatus.approved;
      }
      onFormSubmit({ ...fields });
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const resetFormFields = (fields, currentFieldName) => {
    if (currentFieldName === fieldYesToAllAdvisories) return fields;
    const { resetFields, customResetFields } = fields[currentFieldName];
    let isResetRequired = false;
    const newFields = { ...fields };
    for (let index = 0; index < formStepFields.length; index += 1) {
      const {
        fields: { name, appearsAfterField, value }
      } = formStepFields[index];
      if (name === currentFieldName) {
        isResetRequired = true;
      } else if (isResetRequired) {
        const field = fields[name];
        if (appearsAfterField && field.isVisible)
          newFields[name] = { ...field, isVisible: false, value };
      }
    }
    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
        else delete newFields[fieldName];
      });
    }
    return newFields;
  };

  const isFieldCalculated = (type, value, checked, price) => {
    switch (type) {
      case 'Radio':
        return value === yes && price;
      case 'Checkbox':
        return checked && price;
      default:
        return value && price;
    }
  };

  const calcPriceSeatsWhiteGlove = fields => {
    let result = { dueNow: 0, dueMonthly: 0 };

    if (getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) === yes) {
      const quantity = Number(
        (fields[fieldNumberOfSeatsThatRequireWhiteGlove] &&
          fields[fieldNumberOfSeatsThatRequireWhiteGlove].value) ||
          0
      );
      const paymentType =
        fields[fieldHowCustomerWantToPayForWhiteGlove] &&
        fields[fieldHowCustomerWantToPayForWhiteGlove].value;
      if (paymentType === valueEasyPayment) {
        const newPrice = quantity * priceSeatsWhiteGloveEasyPayment;
        result = { dueNow: 0, dueMonthly: newPrice };
      } else if (paymentType === valuePaymentUpfront) {
        let newPrice = quantity * priceSeatsWhiteGloveUpfront;
        if (Number(getFieldValue(fieldStarterSeat, fields)) === 1) {
          newPrice += priceSitesWhiteGloveFee;
        }
        result = { dueNow: newPrice, dueMonthly: 0 };
      } else {
        result = { dueNow: 0, dueMonthly: 0 };
      }
    }

    return result;
  };

  const updateTotals = (name, field) => {
    const { value, checked, type, price, monthlyPayment, isVisible } = field;

    if (isFieldInFeatures(name)) return;
    if (!isVisible) return;
    if (
      [
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences
      ].includes(name)
    )
      return;

    let oldQuantity;
    let newQuantity;
    let oldPrice;
    let newPrice;

    if (type === 'Number') {
      oldQuantity = (formFields[name] && formFields[name].value) || 0;
      newQuantity = value ? Number(value) : 0;
      if (price > 0) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment > 0) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    } else if (name !== fieldDoesTheCustomerRequireSmartHub) {
      oldQuantity = formFields[name] && formFields[name].value ? 1 : 0;
      newQuantity = value ? 1 : 0;
      if (isFieldCalculated(type, value, checked, price)) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (isFieldCalculated(type, value, checked, monthlyPayment)) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    }
  };

  const isMppEnhancedPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );

    return (
      valueSegment === valueSegmentSmb1To30 &&
      valueBusinessConnectEdition === enhanced
    );
  };

  const isVoicePlusPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );

    return (
      isDealer &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueOtherTelusServices === yes &&
      valueBusinessConnectEdition === voicePlus
    );
  };

  const isCbmEnhancedPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valuePostalCode =
      getFieldValue(fieldPostalCodeServiceAddress, fields) || '';
    const isPostalCodePresent = cbmPromoPostalCodeList.includes(
      valuePostalCode.replace(/\s+/g, '').slice(0, 3)
    );

    return (
      valueSegment === valueSegmentSmb1To30 &&
      valueBusinessConnectEdition === enhanced &&
      isPostalCodePresent
    );
  };

  const isEnhancedPromoAvailable = fields => {
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueIsThisAnExistingGSuiteCustomer = _.get(
      orderData,
      fieldIsThisAnExistingGSuiteCustomer,
      ''
    );
    const valueOptedGoogleWorkspace =
      valueTerm === monthToMonth
        ? true
        : getFieldChecked(fieldOptOutFromGSuiteBusinessLicenses, fields);

    return (
      valueBusinessConnectEdition === enhanced &&
      valueOtherTelusServices === yes &&
      (valueIsThisAnExistingGSuiteCustomer !== no || valueOptedGoogleWorkspace)
    );
  };

  const updateRates = fields => {
    const fieldBCE = checkBusinessConnectEdition(
      fieldBusinessConnectEdition,
      orderData,
      formName,
      yes
    );

    const valueBCE = getFieldValue(fieldBCE, fields);
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueSelectedPromos =
      getFieldValue(fieldAvailableDiscountsAndPromotions, fields) || [];
    const valueBundle =
      valueOtherTelusServices === yes ||
      (valueOtherTelusServices === no &&
        valueSelectedPromos.includes(valueMppPromo))
        ? 'bundled'
        : 'nonBundled';

    const enhancedPromosList = [
      valueEnhancedPromoAvailable,
      valueMppEnhancedPromoAvailable,
      valueCbmEnhancedPromoAvailable
    ];
    const isEnhancedPromoSelected =
      valueBCE === enhanced &&
      valueSelectedPromos.some(promo => enhancedPromosList.includes(promo));

    const isBusinessHeroPromoSelected = valueSelectedPromos.includes(
      valueBusinessHeroPromo
    );

    const isVoicePlusPromoSelected = valueSelectedPromos.includes(
      valueVoicePlusPromo
    );

    let rateStarter = _.get(
      ratesStarterSeat,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );
    let rateOffice = _.get(
      ratesOfficeSeats,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );

    if (isEnhancedPromoSelected) {
      rateStarter = 30;
      rateOffice = 30;
    }

    if (isBusinessHeroPromoSelected) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if (isVoicePlusPromoSelected) {
      rateStarter = 20;
      rateOffice = 20;
    }
    if (isc2fMigrationFlow) {
      const seatRate = getFieldValue(fieldc2fMigrationSeatPrices, fields) || 0;
      rateStarter = seatRate;
      rateOffice = seatRate;
    }
    const quantityStarter = +getFieldValue(fieldStarterSeat, fields) || 0;
    const quantityOffice = +getFieldValue(fieldOfficeSeats, fields) || 0;

    return {
      starterSeatRateStandard: rateStarter,
      officeSeatRateStandard: rateOffice,
      starterSeat: rateStarter * quantityStarter,
      officeSeats: rateOffice * quantityOffice
    };
  };

  const calcDevices = (key, method) => {
    if (formFields[key]) {
      return formFields[key].reduce((acc, item) => {
        const { unitPrice, quantity, paymentType } = item;
        return paymentType === method ? acc + unitPrice * quantity : acc;
      }, 0);
    }

    return 0;
  };

  const supportedDevicesNinetynineCentPromo = [
    devicePolycomVVX250,
    deviceCisco7841
  ];

  const supportedDevicesHardwareCreditPromo = [
    devicePolycomVVX150,
    devicePolycomVVX250,
    devicePolycomVVX350,
    deviceYealinkT43U,
    deviceYealinkT48U,
    deviceYealinkT33G,
    deviceYealinkT43UOld,
    deviceYealinkT48UOld,
    deviceYealinkT33GOld
  ];

  const getDeviceName = device =>
    [devicePolycomVVX150HWC, deviceYealinkT33GHWC].includes(device)
      ? device.replace(' - HWC', '')
      : device.replace(' HWC', '');

  const getDevicePromoPrices = (promo, deviceName) => {
    if (promo.includes(valueNinetyNineCentDevicePromo)) return promoDeviceRate;
    return _.get(hwcPromoDeviceRates, deviceName, 0);
  };

  const isDevicesPromo = fields => {
    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevicesNinetynineCentPromo.includes(getDeviceName(device.name))
    );
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );

    return (
      [valueSegmentCommercial, valueSegmentSmb30To100].includes(valueSegment) &&
      [threeYears, fiveYears].includes(
        getFieldValue(fieldContractTerm, fields)
      ) &&
      getFieldValue(fieldTypeOfInstallation, fields) === valueNew &&
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, fields) ===
        yes &&
      deviceIndex !== -1
    );
  };

  const isHardwareCreditPromo = fields => {
    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevicesHardwareCreditPromo.includes(getDeviceName(device.name))
    );

    return (
      [threeYears, fiveYears].includes(
        getFieldValue(fieldContractTerm, fields)
      ) &&
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, fields) ===
        yes &&
      deviceIndex !== -1
    );
  };

  const getHwcPromoLabel = device =>
    [devicePolycomVVX150, deviceYealinkT33G, deviceYealinkT33GOld].includes(
      device.name
    )
      ? `- ${quoteForm.hwcPromoLabel}`
      : quoteForm.hwcPromoLabel;

  // This function swaps the regular devices with promo device and vice-versa
  const swapRegularDevicesAndPromoDevices = fields => {
    let removeFromMonthly = 0;
    let removeFromNow = 0;
    let addToNow = 0;
    let addToMonthly = 0;
    const deviceList = _.get(fields, keyDevices, []);
    const valuePromotionCodes =
      getFieldValue(fieldAvailableDiscountsAndPromotions, fields) || [];
    const promoDevices = valuePromotionCodes.includes(valueHardwareCreditPromo)
      ? supportedDevicesHardwareCreditPromo
      : supportedDevicesNinetynineCentPromo;

    const updatedDevice = deviceList.map(device => {
      let newDevice = { ...device };

      if (
        promoDevices.includes(getDeviceName(device.name)) &&
        (valuePromotionCodes.includes(valueNinetyNineCentDevicePromo) ||
          valuePromotionCodes.includes(valueHardwareCreditPromo))
      ) {
        const {
          name,
          monthlyCharges,
          oneTimeCharges,
          payForDevice,
          quantity
        } = device;

        const promoLabel = valuePromotionCodes.includes(
          valueHardwareCreditPromo
        )
          ? getHwcPromoLabel(device)
          : quoteForm.promoLabel;
        const promoPrice = getDevicePromoPrices(
          valuePromotionCodes,
          getDeviceName(name)
        );

        if (payForDevice === valuePaymentUpfront) {
          removeFromNow += oneTimeCharges * quantity;
          addToNow += promoPrice * quantity;
        } else if (payForDevice === valueEasyPayment) {
          removeFromMonthly += monthlyCharges * quantity;
          addToNow += promoPrice * quantity;
        }

        /** Added this as the promo device name is different from regular device name */
        let promoDeviceName = getDeviceName(name);
        if (promoDeviceName === deviceYealinkT33G)
          promoDeviceName = 'Yealink T33G';
        if (promoDeviceName === deviceYealinkT43U)
          promoDeviceName = 'Yealink T43U';
        if (promoDeviceName === deviceYealinkT48U)
          promoDeviceName = 'Yealink T48U';

        newDevice.name = `${promoDeviceName} ${promoLabel}`;
        newDevice.oneTimeCharges = promoPrice;
        newDevice.unitPrice = promoPrice;
        newDevice.paymentType = paymentTypeUpfront;
        newDevice.payForDevice = valuePaymentUpfront;
        if (!newDevice.oldData) newDevice.oldData = device;
        newDevice.promoApplied = true;
      } else if (
        _.union(
          supportedDevicesNinetynineCentPromo,
          supportedDevicesHardwareCreditPromo
        ).includes(getDeviceName(device.name)) &&
        device.promoApplied
      ) {
        const { oneTimeCharges, quantity, oldData } = device;

        if (oldData.payForDevice === valuePaymentUpfront) {
          addToNow += oldData.oneTimeCharges * quantity;
        } else if (oldData.payForDevice === valueEasyPayment) {
          addToMonthly += oldData.monthlyCharges * quantity;
        }
        removeFromNow += oneTimeCharges * device.quantity;
        newDevice = { ...device.oldData };
      }

      return newDevice;
    });
    return {
      newDeviceList: updatedDevice,
      removeFromMonthly,
      removeFromNow,
      addToNow,
      addToMonthly
    };
  };

  const isThreeMonthsFreePromo = fields => {
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueIsVbpRequired = getFieldValue(fieldVbpRequired, fields);

    return (
      valueOtherTelusServices === yes &&
      valueContractTerm === threeYears &&
      [enhanced, complete].includes(valueBusinessConnectEdition) &&
      valueIsVbpRequired !== yes
    );
  };

  const isBusinessHeroPromoAvailable = fields => {
    const valueCpmsId = profile.cpms_id;
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);

    return (
      valueCpmsId === 'H5QV' &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueBusinessConnectEdition === complete &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)
    );
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      setIsFieldReset(true);
      setOrderData(updatedOrderData);
    }
  };

  const handleFormField = (
    { name, value, checked },
    isFieldModified,
    fileUploded
  ) => {
    const fields = { ...formFields };
    let needToCheck = 1;
    let addAmountToNow = 0;
    let addAmountToMonthly = 0;
    let subtractAmountFromNow = 0;
    let subtractAmountFromMonthly = 0;

    setIsFieldReset(false);
    setIsFormValidated(false);
    setIsVBP(false);

    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }
    fields[name] = {
      ...fields[name],
      value,
      checked,
      isVisible: true,
      touched: true
    };

    if (fields[name].type === 'MultiCheckbox') {
      fields[name].options = getMultiCheckboxOptions(
        fields[name].options,
        value,
        name,
        fields,
        orderData
      );
    }

    /**
     * Auto select all adivsories to YES
     * when Yes to ALL is selected
     */
    if (name === fieldYesToAllAdvisories) {
      Object.keys(fields).forEach(field => {
        if (field.includes('customerAdvisories') && fields[field].isVisible) {
          fields[field].checked = checked;
          fields[field].value = checked;
        }
      });
    }

    if (fields[name].type === 'MultiFileUpload') {
      fields[name] = { ...fields[name], fileUploded };
      formFields[name] = { ...formFields[name], fileUploded };
      formStepFields[name] = { ...formStepFields[name], fileUploded };
    }

    if (isMultisiteOrder && step === 1) {
      /**
       * Defaulting starter seat to 1 for all multi-sites AND
       * Defaulting installation type to Add-on for site 2/3/4 etc
       */

      if (name !== fieldStarterSeat && !fields[fieldStarterSeat].value)
        fields[fieldStarterSeat].value = '1';
      if (currentSite > 1) {
        fields[fieldTypeOfInstallation].value = valueAddon;
        fields[fieldTypeOfInstallation].isDisabled = true;
      }
    }

    /**
     * Defaulting starter seat to 1  if Installation type is new
     * for all non multi-sites orders
     */

    if (name === fieldTypeOfInstallation && !isMultisiteOrder)
      if (value === valueNew) {
        fields[fieldStarterSeat].value = '1';
        fields[fieldStarterSeat].isDisabled = true;
      } else {
        fields[fieldStarterSeat].value = '';
        fields[fieldStarterSeat].isDisabled = false;
      }

    /**
     * if C2F Automated Action is required then
     * default installation type to New and disable Add On option
     */
    if (
      _.get(orderData, fieldC2fAutomatedActivation, '') === yes &&
      _.get(fields, fieldTypeOfInstallation, false)
    ) {
      fields[fieldTypeOfInstallation].value = valueNew;
      fields[fieldTypeOfInstallation].isDisabled = true;
    }

    /**
     * Defaulting Number of sites require WG to 1
     */
    if (
      isMultisiteOrder &&
      step === 4 &&
      _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, no) === yes
    )
      fields[fieldNumberOfSitesThatRequireWhiteGlove].value = 1;

    if ([fieldStarterSeat, fieldOfficeSeats].includes(name)) {
      // Custom logic for related fields
      const relatedFieldNames = [
        fieldNumberOfSeatsThatRequireWhiteGlove,
        fieldTelusBusinessConnectRoomsNumberOfLicences,
        fieldTelusBusinessConnectLiveReportsNumberOfLicences,
        fieldTelusBusinessConnectRoomConnectorNumberOfLicences,
        fieldAdditionalTollFreeNumbersNumber
      ];
      const additionalField =
        name === fieldStarterSeat ? fieldOfficeSeats : fieldStarterSeat;
      const defaultValue =
        Number(value) + Number(getFieldValue(additionalField, fields));
      relatedFieldNames.forEach(item => {
        const values = { maxValue: defaultValue };
        if (item === fieldNumberOfSeatsThatRequireWhiteGlove) {
          values.value = defaultValue;
        }
        if (item === fieldAdditionalTollFreeNumbersNumber) {
          values.maxValue = getFieldValue(fieldOfficeSeats, fields);
        }
        fields[item] = { ...fields[item], ...values };
      });
      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    } else if (
      [
        fieldNumberOfSeatsThatRequireWhiteGlove,
        fieldHowCustomerWantToPayForWhiteGlove,
        fieldDoesTheCustomerRequireWhiteGlove
      ].includes(name) &&
      checkBusinessConnectEdition(
        fieldBusinessConnectEdition,
        orderData,
        formName,
        yes
      ) !== fieldBusinessConnectEditionWorkplace
    ) {
      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    } else if (name === fieldBusinessConnectEdition) {
      if (value === mobile) {
        subtractAmountFromNow += calcDevices(keyDevices, paymentTypeUpfront);
        subtractAmountFromMonthly += calcDevices(
          keyDevices,
          paymentTypeEasyPayment
        );
        subtractAmountFromNow += calcDevices(
          keySpareDevices,
          paymentTypeUpfront
        );
        subtractAmountFromMonthly += calcDevices(
          keySpareDevices,
          paymentTypeEasyPayment
        );
      }
    } else if (name === fieldDoesCustomerRequirePrimaryIpDeskPhones) {
      let valueNow = calcDevices(keyDevices, paymentTypeUpfront);
      let valueMonthly = calcDevices(keyDevices, paymentTypeEasyPayment);

      if (
        fields[fieldDoesCustomerRequireSpareDevices] &&
        fields[fieldDoesCustomerRequireSpareDevices].value === yes
      ) {
        valueNow += calcDevices(keySpareDevices, paymentTypeUpfront);
        valueMonthly += calcDevices(keySpareDevices, paymentTypeEasyPayment);
      }
      if (value === yes) {
        addAmountToNow += valueNow;
        addAmountToMonthly += valueMonthly;
      } else {
        subtractAmountFromNow += valueNow;
        subtractAmountFromMonthly += valueMonthly;
      }
      fields[keyDevices] = [];
    } else if (name === fieldDoesCustomerRequireSpareDevices) {
      const valueNow = calcDevices(keySpareDevices, paymentTypeUpfront);
      const valueMonthly = calcDevices(keySpareDevices, paymentTypeEasyPayment);
      if (value === yes) {
        addAmountToNow += valueNow;
        addAmountToMonthly += valueMonthly;
      } else {
        subtractAmountFromNow += valueNow;
        subtractAmountFromMonthly += valueMonthly;
      }
    } else if ([fieldContractTerm, fieldTypeOfInstallation].includes(name)) {
      if (!isDevicesPromo(fields) && fields[keyDevices]) {
        subtractAmountFromNow += fields[keyDevices].reduce((acc, item) => {
          const { unitPrice, quantity } = item;
          return [devicePolycomVVX250Promo, deviceCisco7841Promo].includes(
            item.name
          )
            ? acc + unitPrice * quantity
            : acc;
        }, 0);
        fields[keyDevices] = fields[keyDevices].filter(
          item =>
            ![devicePolycomVVX250Promo, deviceCisco7841Promo].includes(
              item.name
            )
        );
      }

      if (!isHardwareCreditPromo(fields) && fields[keyDevices]) {
        subtractAmountFromNow += fields[keyDevices].reduce((acc, item) => {
          const { unitPrice, quantity } = item;
          return [
            devicePolycomVVX150HWC,
            devicePolycomVVX250HWC,
            devicePolycomVVX350HWC,
            deviceYealinkT43UHWC,
            deviceYealinkT48UHWC,
            deviceYealinkT33GHWC
          ].includes(item.name)
            ? acc + unitPrice * quantity
            : acc;
        }, 0);
        fields[keyDevices] = fields[keyDevices].filter(
          item =>
            ![
              devicePolycomVVX150HWC,
              devicePolycomVVX250HWC,
              devicePolycomVVX350HWC,
              deviceYealinkT43UHWC,
              deviceYealinkT48UHWC,
              deviceYealinkT33GHWC
            ].includes(item.name)
        );
      }

      if (
        name === fieldContractTerm &&
        getFieldValue(fieldContractTerm, fields) &&
        !getFieldValue(fieldVbpTerm, fields)
      ) {
        fields[fieldVbpTerm].value = getFieldValue(fieldContractTerm, fields);
      }
    } else if (name === fieldGSuiteEmailMigrationServices) {
      if (getFieldValue(fieldGSuiteEmailMigrationServices, fields) < 5) {
        fields[fieldGSuiteEmailMigrationServicesPaymentType].value = '';
      }
    } else if (name === fieldAvailableDiscountsAndPromotions) {
      const valueAvailableDiscountsAndPromotions =
        getFieldValue(name, fields) || [];
      if (valueAvailableDiscountsAndPromotions.includes(valueThreeMonthsFree))
        fields[fieldVbpRequired].value = no;
    } else if (
      name === fieldDoesTheCustomerHaveAnExistingInternetConnection &&
      value === yes
    ) {
      fields[fieldWhoIsTheExistingInternetProviderForOtherState].value = other;
    } else {
      // Handle dueMonthly and dueNow
      updateTotals(name, fields[name]);

      if (['Select', 'Radio'].includes(fields[name].type)) {
        const currentField = findField(formStepFields, name);
        if (
          currentField &&
          currentField.fields &&
          currentField.fields.options
        ) {
          const currentOption = currentField.fields.options.find(
            item => item.fields.value === value
          );

          // field doesTheCustomerRequireSmartHub
          if (name === fieldDoesTheCustomerRequireSmartHub) {
            if (currentOption.fields.value === yes) {
              addAmountToMonthly += fields[name].monthlyPayment;
            } else {
              subtractAmountFromMonthly += fields[name].monthlyPayment;
            }
          } else if (typeof currentOption !== 'undefined') {
            // Price
            let amount = currentOption.fields.price || 0;
            let oldPrice = fields[name].price || 0;
            if (!isFieldInFeatures(name)) {
              subtractAmountFromNow += oldPrice;
              addAmountToNow += amount;
            }
            fields[name].price = amount;

            // Monthly payment
            amount = currentOption.fields.monthlyPayment || 0;
            oldPrice = fields[name].monthlyPayment || 0;
            if (!isFieldInFeatures(name)) {
              subtractAmountFromMonthly += oldPrice;
              addAmountToMonthly += amount;
            }
            fields[name].monthlyPayment = amount;
          } else {
            if (fields[name].price) {
              if (!isFieldInFeatures(name)) {
                subtractAmountFromNow += fields[name].price;
              }
              fields[name].price = 0;
            }
            if (fields[name].monthlyPayment) {
              if (!isFieldInFeatures(name)) {
                subtractAmountFromMonthly += fields[name].monthlyPayment;
              }
              fields[name].monthlyPayment = 0;
            }
          }
        }
      }
    }

    if (
      [
        fieldDoesCustomerRequirePrimaryIpDeskPhones,
        fieldAvailableDiscountsAndPromotions
      ].includes(name)
    ) {
      const {
        newDeviceList,
        removeFromMonthly,
        removeFromNow,
        addToNow,
        addToMonthly
      } = swapRegularDevicesAndPromoDevices(fields);

      fields[keyDevices] = newDeviceList;
      addAmountToNow += addToNow;
      subtractAmountFromNow += removeFromNow;
      subtractAmountFromMonthly += removeFromMonthly;
      addAmountToMonthly += addToMonthly;
    }

    if (
      [
        fieldTypeOfInstallation,
        fieldStarterSeat,
        fieldOfficeSeats,
        fieldBusinessConnectEdition,
        fieldBusinessConnectEditionWorkplace,
        fieldContractTerm,
        fieldOtherTelusServices,
        fieldAvailableDiscountsAndPromotions,
        fieldc2fMigrationSeatPrices
      ].includes(name)
    ) {
      // Get rates for Starter and Office
      const newRates = updateRates(fields);
      addAmountToMonthly += newRates.starterSeat + newRates.officeSeats;
      subtractAmountFromMonthly += rates.starterSeat + rates.officeSeats;
      setRates(newRates);
    }

    // Update G Suite price
    if (
      [
        fieldContractTerm,
        fieldBusinessConnectEdition,
        fieldStarterSeat,
        fieldOfficeSeats,
        fieldOptOutFromGSuiteBusinessLicenses,
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences,
        fieldGSuiteInstallAndSetup,
        fieldGSuiteEmailMigrationServices,
        fieldGSuiteEmailMigrationServicesPaymentType
      ].includes(name)
    ) {
      const newPriceGSuite = getGSuitePrice(fields);
      addAmountToNow += newPriceGSuite.price;
      addAmountToMonthly += newPriceGSuite.monthlyPayment;
      subtractAmountFromNow += priceGSuite.price;
      subtractAmountFromMonthly += priceGSuite.monthlyPayment;
      setPriceGSuite(newPriceGSuite);
    }

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));

    const getDisabledFields = (data, initFields) => {
      let result = initFields;

      const filter = !data
        ? []
        : data.filter(item => {
            const { sys, fields: itemFields } = item;
            const {
              name: itemName,
              appearsAfterField,
              eligible: eligibleField,
              ineligible,
              ineligibleNote
            } = itemFields;
            const {
              contentType: {
                sys: { id }
              }
            } = sys;
            if (name === itemName) {
              if (eligibleField) {
                const {
                  fields: { value: eligibleValue }
                } = eligibleField;
                setEligible({
                  isEligible:
                    eligibleValue === value ||
                    // eslint-disable-next-line eqeqeq
                    (eligibleValue === requiredValue && !!value && value != 0),
                  note: {}
                });
              } else if (ineligible) {
                const {
                  fields: { value: ineligibleValue }
                } = ineligible;
                const isIneligibleValue = ineligibleValue
                  .split('|')
                  .includes(value);
                setEligible({
                  isEligible: false,
                  note: isIneligibleValue ? ineligibleNote : {}
                });
              }
              /**
               * For CTF migration if Yes is selected
               * set eligibility to true on province selection
               */
              if (name === fieldProvinceOfTheOrder) {
                const valueCoperToFibreMigration = getFieldValue(
                  fieldCoperToFibreMigration,
                  formFields
                );
                if (valueCoperToFibreMigration === yes)
                  setEligible({
                    isEligible: true,
                    note: {}
                  });
              }
            }

            if (id === formFieldsGroup) {
              result = getDisabledFields(itemFields.fields, result);
            } else if (id === formSection) {
              result = getDisabledFields(itemFields.formFields, result);
            } else if (fields[itemName] && appearsAfterField) {
              const isVisible = isRelatedFieldExisted(item.fields, fields);
              if (fields[itemName].isVisible) {
                fields[itemName].isVisible = isVisible;
                return !isVisible;
              }
              if (
                isVisible &&
                !isFieldInFeatures(itemName) &&
                ![
                  fieldAdditionalGSuiteBusinessLicences,
                  fieldGSuiteBasicLicences
                ].includes(itemName)
              ) {
                if (
                  isFieldCalculated(
                    fields[itemName].type,
                    fields[itemName].value,
                    fields[itemName].checked,
                    fields[itemName].price
                  )
                ) {
                  const itemPrice =
                    fields[itemName].type === 'Number'
                      ? Number(fields[itemName].initPrice) *
                        Number(fields[itemName].value)
                      : Number(fields[itemName].price);
                  addAmountToNow += itemPrice;
                }
                if (
                  isFieldCalculated(
                    fields[itemName].type,
                    fields[itemName].value,
                    fields[itemName].checked,
                    fields[itemName].monthlyPayment
                  )
                ) {
                  const itemPrice =
                    fields[itemName].type === 'Number'
                      ? Number(fields[itemName].initMonthlyPayment) *
                        Number(fields[itemName].value)
                      : Number(fields[itemName].monthlyPayment);
                  addAmountToMonthly += itemPrice;
                }
              }
              fields[itemName].isVisible = isVisible;
            }

            return false;
          });

      return [...result, ...filter];
    };

    while (needToCheck > 0 && needToCheck < 5) {
      const disabledFields = getDisabledFields(formStepFields, []);

      // eslint-disable-next-line no-loop-func
      disabledFields.forEach(item => {
        const {
          fields: { name: itemName }
        } = item;

        if (
          !isFieldInFeatures(itemName) &&
          ![
            fieldAdditionalGSuiteBusinessLicences,
            fieldGSuiteBasicLicences
          ].includes(itemName)
        ) {
          if (
            isFieldCalculated(
              fields[itemName].type,
              fields[itemName].value,
              fields[itemName].checked,
              fields[itemName].price
            )
          ) {
            const itemPrice =
              fields[itemName].type === 'Number'
                ? Number(fields[itemName].initPrice) *
                  Number(fields[itemName].value)
                : Number(fields[itemName].price);
            subtractAmountFromNow += itemPrice;
          }
          if (
            isFieldCalculated(
              fields[itemName].type,
              fields[itemName].value,
              fields[itemName].checked,
              fields[itemName].monthlyPayment
            )
          ) {
            const itemPrice =
              fields[itemName].type === 'Number'
                ? Number(fields[itemName].initMonthlyPayment) *
                  Number(fields[itemName].value)
                : Number(fields[itemName].monthlyPayment);
            subtractAmountFromMonthly += itemPrice;
          }
        }
      });

      needToCheck = disabledFields.length > 0 ? needToCheck + 1 : 0;
    }

    // Update features price
    const newFeaturesPrice = updateFeaturesPrices(getFeatures(fields));
    addAmountToMonthly += _.get(newFeaturesPrice, 'monthly', 0);
    subtractAmountFromMonthly += _.get(priceFeatures, 'monthly', 0);
    addAmountToNow += _.get(newFeaturesPrice, 'oneTime', 0);
    subtractAmountFromNow += _.get(priceFeatures, 'oneTime', 0);
    setPriceFeatures(newFeaturesPrice);

    // Update prices
    if (addAmountToNow || subtractAmountFromNow) {
      setDueNow(dueNow - subtractAmountFromNow + addAmountToNow);
    }
    if (addAmountToMonthly || subtractAmountFromMonthly) {
      setDueMonthly(
        dueMonthly - subtractAmountFromMonthly + addAmountToMonthly
      );
    }

    // Update form fields
    setFormFields(resetFormFields(fields, name));

    // Reset Selected Fields Logic
    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }
  };

  useEffect(() => {
    const formFieldsKeys = Object.keys(formFields);
    if (formFieldsKeys.length) {
      const initFieldsWithValue = [];
      formFieldsKeys.forEach(name => {
        const { value } = formFields[name];
        if (value) {
          initFieldsWithValue.push({ name, value });
          updateTotals(name, formFields[name]);
        }
      });
      setFieldsWithValue(initFieldsWithValue);
    }
  }, [Object.keys(formFields).length, orderData]);

  useEffect(() => {
    if (ratesStarterSeat && ratesOfficeSeats) {
      if (typeof fieldsWithValue === 'undefined' || !fieldsWithValue.length)
        return;

      // Get custom amounts
      const totalPlan = calcFieldMonthlyPayment(
        fieldPlan,
        getFieldValue(fieldPlan, formFields),
        formStepFields
      );
      const totalSmartHub =
        getFieldValue(fieldDoesTheCustomerRequireSmartHub, formFields) === yes
          ? formFields[fieldDoesTheCustomerRequireSmartHub].monthlyPayment
          : 0;
      // Get main amounts
      const totalPriceFeatures = orderData.features
        ? updateFeaturesPrices(orderData.features)
        : { monthly: 0, oneTime: 0 };
      const totalRates = updateRates(formFields);

      const totalNowDevices = calcDevices(keyDevices, paymentTypeUpfront);
      const totalMonthlyDevices = calcDevices(
        keyDevices,
        paymentTypeEasyPayment
      );
      const totalNowSpareDevices = calcDevices(
        keySpareDevices,
        paymentTypeUpfront
      );
      const totalMonthlySpareDevices = calcDevices(
        keySpareDevices,
        paymentTypeEasyPayment
      );

      /**
       * Router
       */
      const valueRouterPaymentOption = getFieldValue(
        fieldRouterPaymentOption,
        formFields
      );
      let valueRouterUpfront = 0;
      let valueRouterMonthly = 0;
      if (valueRouterPaymentOption === valueEasyPayment)
        valueRouterMonthly =
          formFields[fieldRouterPaymentOption].monthlyPayment;
      else if (valueRouterPaymentOption === valuePaymentUpfront)
        valueRouterUpfront = formFields[fieldRouterPaymentOption].price;

      // G Suite
      const totalGSuite = getGSuitePrice(formFields);
      const totalNowGSuite = totalGSuite.price;
      const totalMonthlyGSuite = totalGSuite.monthlyPayment;

      // Add prices from the order data
      let newDueNow =
        totalNowDevices +
        totalNowSpareDevices +
        totalNowGSuite +
        _.get(totalPriceFeatures, 'oneTime', 0) +
        valueRouterUpfront;
      let newDueMonthly =
        totalPlan +
        totalSmartHub +
        totalRates.starterSeat +
        totalRates.officeSeats +
        _.get(totalPriceFeatures, 'monthly', 0) +
        totalMonthlyDevices +
        totalMonthlySpareDevices +
        totalMonthlyGSuite +
        valueRouterMonthly;
      if (
        checkBusinessConnectEdition(
          fieldBusinessConnectEdition,
          orderData,
          formName,
          yes
        ) !== fieldBusinessConnectEditionWorkplace
      ) {
        const totalPriceSeatsWhiteGlove = calcPriceSeatsWhiteGlove(formFields);
        newDueNow += totalPriceSeatsWhiteGlove.dueNow;
        newDueMonthly += totalPriceSeatsWhiteGlove.dueMonthly;
        setPriceSeatsWhiteGlove(totalPriceSeatsWhiteGlove);
      }
      setDueNow(newDueNow);
      setDueMonthly(newDueMonthly);
      setPriceFeatures(totalPriceFeatures);
      setRates(totalRates);
      setPriceGSuite(totalGSuite);
    }
  }, [fieldsWithValue, ratesStarterSeat, ratesOfficeSeats]);

  const renderFormSummary = (formSummaryGroup, data = orderData) => {
    let summaryData = data;
    if (formName === businessConnectQuoteToolForm) {
      summaryData = { ...profile, ...summaryData };
    }

    if (isSalesSupport) {
      summaryData = {
        handleFormField,
        isSelectAllowed: formName === businessConnectQuoteToolForm,
        ref: formFields[keyChannelId] && formFields[keyChannelId].ref,
        error:
          formErrors &&
          formErrors[keyChannelId] &&
          formErrors[keyChannelId].text,
        ...summaryData
      };
    }
    if (isVarAgent) {
      summaryData = {
        handleFormField,
        isSelectAllowed: formName === businessConnectQuoteToolForm,
        ref: formFields[keyOutlet] && formFields[keyOutlet].ref,
        error:
          formErrors && formErrors[keyOutlet] && formErrors[keyOutlet].text,
        ...summaryData
      };
    }

    return <FormSummaryGroup data={formSummaryGroup} orderData={summaryData} />;
  };

  const isCrossSellCreditPromoAvailable = fields => {
    const valueIsTelusWorkplaceOrder = _.get(
      orderData,
      fieldIsThisOrderAPartOfTELUSWorkplace,
      no
    );
    const valueBundleServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    return (
      [valueSegmentCommercial, valueSegmentSmb30To100].includes(valueSegment) &&
      valueIsTelusWorkplaceOrder !== yes &&
      valueBundleServices === yes
    );
  };

  const isMppPromo = () => {
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    return valueSegment === valueSegmentSmb1To30;
  };

  const getPromotionList = (list, fields) => {
    let promoList = list;
    if (!isDevicesPromo(fields)) {
      promoList = promoList.filter(
        item => ![valueNinetyNineCentDevicePromo].includes(item.fields.value)
      );
    }
    if (!isHardwareCreditPromo(fields)) {
      promoList = promoList.filter(
        item => ![valueHardwareCreditPromo].includes(item.fields.value)
      );
    }
    if (!isCrossSellCreditPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueCrossSellCredit].includes(item.fields.value)
      );
    }

    if (!isThreeMonthsFreePromo(fields)) {
      promoList = promoList.filter(
        item => ![valueThreeMonthsFree].includes(item.fields.value)
      );
    }

    if (!isMppPromo(fields)) {
      promoList = promoList.filter(
        item => ![valueMppPromo].includes(item.fields.value)
      );
    }
    if (!isEnhancedPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueEnhancedPromoAvailable].includes(item.fields.value)
      );
    }
    if (!isMppEnhancedPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueMppEnhancedPromoAvailable].includes(item.fields.value)
      );
    }
    if (!isCbmEnhancedPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueCbmEnhancedPromoAvailable].includes(item.fields.value)
      );
    }

    if (!isBusinessHeroPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueBusinessHeroPromo].includes(item.fields.value)
      );
    }

    if (!isVoicePlusPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => ![valueVoicePlusPromo].includes(item.fields.value)
      );
    }

    return promoList;
  };

  let readonly = false;

  const editSite = siteData => {
    const { id, locale, categoryName } = siteData;
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=1`
    });
    setOrderData(siteData);
  };

  const renderMultiSiteSummary = data => {
    return multiSiteOrderSummaryData.map(siteOrderData => {
      const { id, currentSite: currentSiteNumber } = siteOrderData;
      return (
        <ExpandCollapse.Panel
          key={id}
          id={id}
          header={`Site ${currentSiteNumber}`}
        >
          <div style={{ float: 'right', marginTop: '2rem' }}>
            <Button
              onClick={() => {
                editSite(siteOrderData);
              }}
            >
              Edit
            </Button>
          </div>
          <div style={{ padding: '1rem' }}>
            <ExpandCollapse tag="h2" topDivider={false}>
              {data &&
                data.map(({ sys, fields }, index) => {
                  const { id: sysId } = sys;
                  const { name: fieldName, title } = fields;
                  const key = `FormField${fieldName}${index}${sysId}`;
                  const { note, formSummaryGroup } = fields;
                  readonly =
                    isAdminFlow &&
                    ![
                      fieldCustomerInformation,
                      fieldOfferConfiguration
                    ].includes(fieldName);
                  const result = sectionIsVisible(fieldName) && (
                    <ExpandCollapse.Panel
                      key={key}
                      id={fieldName}
                      header={title}
                    >
                      <>
                        {note && note.content && (
                          <Note data={note} type="richText" />
                        )}
                        {formSummaryGroup &&
                          renderFormSummary(formSummaryGroup, siteOrderData)}
                      </>
                    </ExpandCollapse.Panel>
                  );
                  return result;
                })}
            </ExpandCollapse>
          </div>
        </ExpandCollapse.Panel>
      );
    });
  };

  useEffect(() => {
    if (isLastStep && isMultisiteOrder) {
      const { groupId } = orderData;
      request.get(`/orders/${groupId}/group`).then(resp => {
        setMultiSiteOrderSummaryData(_.get(resp, 'data.results', []));
      });
    }
  }, [step]);

  useEffect(() => {
    document.getElementById('footer').style.display = 'none';
    document.getElementById('introduction').style.marginBottom = '7rem';

    return () => {
      document.getElementById('footer').style.display = '';
      document.getElementById('introduction').style.marginBottom = '0';
    };
  }, []);

  const renderFormFields = data =>
    data &&
    data.map(({ sys, fields }, index) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title, expiredDate, type, note2 } = fields;
      let fieldValue = getFieldValue(fieldName, formFields);
      const fieldDateConfig = {};
      let selectOptions = _.get(fields, 'options', []);
      let isRequired = fields.required || false;
      let fieldNote = fields.note;
      let fieldNote2 = note2;

      if (
        fieldName === groupDirectoryListing &&
        orderData[keyDirectoryListingType] &&
        orderData[keyDirectoryListingType].length === 0
      )
        return null;

      if (fieldName === fieldWhoIsTheExistingInternetProviderForOtherState)
        return null;

      if (
        fieldName === fieldeContractNumber &&
        (isc2fMigrationFlow || !_.get(orderData, 'assignedToSRT', 0))
      )
        return null;

      if (
        fieldName === fieldBAN &&
        !_.get(orderData, 'assignedToSRT', 0) &&
        !isOrderFulfillmentTeam
      )
        return null;

      if (
        fieldName === fieldBusinessConnectImplementationTollFreeNumber &&
        isc2fMigrationFlow &&
        !isOrderFulfillmentTeam
      )
        return null;

      if (fieldName === fieldMultisiteOrder && !fieldValue) {
        if (!prequalEligibility.isEligible) return null;
      }

      if (
        fieldName === fieldAdditionalRsiOptions &&
        !isAdditionalRsiOptionsAvailable()
      )
        return null;

      if (fieldName === fieldIsSrtTeamMember && !isSalesRep) {
        return null;
      }

      if (type === 'MultiCheckbox') {
        selectOptions = formFields[fieldName].options;
      }

      if (fieldName === fieldAvailableDiscountsAndPromotions) {
        if (
          !(formFields[fieldName].value && formFields[fieldName].value.length)
        ) {
          if (formFields[fieldName].options.length) {
            formFields[fieldName].options.forEach((item, i) => {
              formFields[fieldName].options[i].checked = false;
            });
          }
        }
        selectOptions = getPromotionList(
          formFields[fieldName].options,
          formFields
        );
      } else if (fieldName === fieldHowCustomerWantToPayForWhiteGlove) {
        /**
         * Removing Dealer Billed Direct option if
         * current user is not a Dealer or a Var Agent (user with channel Indirect Sales)
         */

        if (!isDealer && !isVarAgent) {
          selectOptions = fields.options.filter(
            item => ![valueDealerBilledDirect].includes(item.fields.value)
          );
        }
        /**
         * Add TELUS Prof. Installation CO Turndown Promo
         * to WG payment method when C2F migration flow is yes
         * or else hide it
         */
        if (!isc2fMigrationFlow) {
          selectOptions = selectOptions.filter(
            item => item.fields.value !== valueInstallationCoTurndownPromo
          );
        }
      } else if (fieldName === fieldContractStartDate) {
        fieldDateConfig.minDays = 0;
        fieldDateConfig.maxDays = 10;
      } else if (fieldName === fieldDriversLicenseExpiry) {
        fieldDateConfig.minDays = 0;
      } else if (fieldName === fieldDateOfBirth) {
        fieldDateConfig.maxDays = 0;
      } else if (
        fieldName === fieldContractTerm &&
        getFieldValue(fieldBusinessConnectEdition, formFields) === mobile
      ) {
        selectOptions = fields.options.filter(
          item => item.fields.value === monthToMonth
        );
      } else if (
        fieldName === fieldContractTerm &&
        _.get(orderData, fieldIsThisOrderAPartOfTELUSWorkplace, '') === yes
      ) {
        selectOptions = fields.options.filter(
          item => item.fields.value !== monthToMonth
        );
      } else if (fieldName === fieldBusinessConnectEdition) {
        let editionList = fields.options;
        if (
          [threeYears, fiveYears].includes(
            getFieldValue(fieldContractTerm, formFields)
          )
        ) {
          editionList = editionList.filter(
            item => item.fields.value !== mobile
          );
        }

        if (
          _.get(orderData, fieldIsThisOrderForAMobileOrVoiceEdition, '') === yes
        ) {
          editionList = editionList.filter(item =>
            [mobile, voice].includes(item.fields.value)
          );
        }
        selectOptions = editionList;
      } else if (fieldName === fieldVbpRequired) {
        const valueAvailableDiscountsAndPromotions =
          getFieldValue(fieldAvailableDiscountsAndPromotions, formFields) || [];
        if (
          valueAvailableDiscountsAndPromotions.includes(valueThreeMonthsFree)
        ) {
          selectOptions = fields.options.filter(
            item => item.fields.value === no
          );
        }
      } else if (
        fieldName === fieldExistingBusinessConnectBANNumber &&
        isMultisiteOrder &&
        currentSite > 1 &&
        !isOrderFulfillmentTeam
      ) {
        isRequired = false;
        return null;
      } else if (
        fieldName === fieldNumberOfSitesThatRequireWhiteGlove &&
        isMultisiteOrder &&
        _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, no) === yes
      )
        fieldValue = 1;
      else if (
        fieldName === fieldTypeOfInstallation &&
        isMultisiteOrder &&
        currentSite > 1
      )
        selectOptions = fields.options.filter(item =>
          [valueAddon].includes(item.fields.value)
        );
      else if (
        fieldName === fieldNumberOfSitesThatRequireWhiteGlove &&
        isMultisiteOrder &&
        _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, no) === yes
      )
        fieldValue = 1;
      else if (fieldName === fieldDealerNote && !isDealer) return null;
      else if (
        fieldName === fieldUploadCustomerReadinessChecklist &&
        !isReadinessChecklistAvailable()
      )
        return null;

      /**
       * Filter provinces to AB & BC
       * when C2F migration flow is yes
       */

      if (fieldName === fieldProvinceOfTheOrder) {
        const valueCoperToFibreMigration = getFieldValue(
          fieldCoperToFibreMigration,
          formFields
        );
        if (valueCoperToFibreMigration === yes) {
          selectOptions = fields.options.filter(item =>
            [valueAlberta, valueBritishColumbia].includes(item.fields.value)
          );
        }
      }

      /**
       * Filter editions to Voice & Voice +
       * when C2F migration flow is yes
       */

      if (fieldName === fieldBusinessConnectEdition) {
        if (isc2fMigrationFlow) {
          selectOptions = fields.options.filter(item =>
            [voice, voicePlus].includes(item.fields.value)
          );
        }
      }

      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${index}${sysId}`;
      let result;

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields)) return null;

      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(itemFields, formFields)
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          const groupFields = renderFormFields(fields.fields);
          if (fieldName === 'advisory') {
            result = groupFields.filter(item => item).length > 0 && (
              <GroupWrapperStyled key={key}>{groupFields}</GroupWrapperStyled>
            );
          } else {
            result = groupFields.filter(item => item).length > 0 && (
              <GroupWrapper key={key}>
                {title && <GroupTitle>{title}</GroupTitle>}
                {groupFields}
              </GroupWrapper>
            );
          }
        }
      } else if (id === formSection) {
        const { note, formSummaryGroup } = fields;

        readonly =
          !isMultisiteOrder &&
          isOrderFulfillmentTeam &&
          ![fieldCustomerInformation, fieldOfferConfiguration].includes(
            fieldName
          );

        result = sectionIsVisible(fieldName) && (
          <ExpandCollapse.Panel key={key} id={fieldName} header={title}>
            <>
              <DimpleDivider />
              {note && note.content && <Note data={note} type="richText" />}
              {formSummaryGroup
                ? renderFormSummary(formSummaryGroup)
                : renderFormFields(fields.formFields)}
            </>
          </ExpandCollapse.Panel>
        );
      } else if (id === userDetailsKey) {
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            resetSelectedFields={resetSelectedFields}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            isMultisiteOrder={isMultisiteOrder}
          />
        );
      } else if (id === seatDetailsFormKey) {
        result = (
          <SeatDetailsForm
            key={key}
            data={fields}
            orderData={orderData}
            updateStep={updateStep}
            step={step}
            setOrderData={setOrderData}
            onSaveAndExit={onSaveAndExit}
            isOrderFulfillmentTeam={isOrderFulfillmentTeam}
            prevStep={prevStep}
          />
        );
      } else {
        const fieldButtonProps =
          fields.type === 'Button'
            ? {
                modalForms,
                formFields,
                setFormFields,
                dueNow,
                setDueNow,
                dueMonthly,
                setDueMonthly,
                setIsFormTouched,
                setIsFormValidated,
                isOrderFulfillmentTeam,
                isDevicesPromo: isDevicesPromo(formFields),
                isHardwareCreditPromo: isHardwareCreditPromo(formFields)
              }
            : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }

        /**
         * If MSFT Directing routing is selected then display
         * a warning message AND if total seats are less then 25
         * then display another warning message
         */
        if (fieldName === 'msftDirectRouting') {
          if (!getFieldChecked('msftDirectRouting', formFields)) {
            fieldNote = '';
            fieldNote2 = '';
          } else {
            const valueStarterSeat = getFieldValue(
              fieldStarterSeat,
              formFields
            );
            const valueOfficeSeat = getFieldValue(fieldOfficeSeats, formFields);
            if (+valueStarterSeat + +valueOfficeSeat > 25) fieldNote2 = '';
          }
        }

        /**
         * if C2F Automated Action is required then
         * default installation type to New and disable Add On option
         */
        if (
          fieldName === fieldTypeOfInstallation &&
          _.get(orderData, fieldC2fAutomatedActivation, '') === yes
        ) {
          fieldValue = valueNew;
          selectOptions = fields.options.map(option => {
            const optionCopy = { ...option };
            if (_.get(option, 'fields.value', '') === valueAddon) {
              optionCopy.fields.disabled = true;
            }
            return optionCopy;
          });
        }

        const fieldData = {
          ...fields,
          options: selectOptions || fields.options,
          ...fieldButtonProps,
          ref,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          required: isRequired,
          note: fieldNote,
          note2: fieldNote2,
          sysId,
          onChange: (e, isFieldModified = true, fileUploded) =>
            handleFormField(e.target, isFieldModified, fileUploded),
          fieldDateConfig,
          readonly,
          formFields,
          setFormFields,
          setOrderData,
          resetSelectedFields
        };

        if (fields.type === 'Checkbox') {
          fieldData.checked = formFields[fieldName].checked;
        }

        result = (
          <>
            {fieldName === fieldOptOutFromGSuiteBusinessLicenses && (
              <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                {stringInterpolation(
                  gSuiteNote,
                  gSuiteBusinessLicences(formFields)
                ).concat(` ${gSuiteNote2}`)}
              </div>
            )}
            <FormField
              key={key}
              orderData={orderData}
              data={fieldData}
              error={error && error.text}
            />
          </>
        );
      }
      return result;
    });

  const getSummary = () => {
    if (formSummary) {
      const {
        fields: { formSummaryGroup }
      } = formSummary;

      return formSummaryGroup.map((summaryGroup, index) => {
        const {
          fields: { name, formFields: summaryGroupFields }
        } = summaryGroup;
        const key = `formSummaryGroup${index}`;

        return (
          <Fragment key={key}>
            <h1>{name}</h1>
            <SummaryGroupWrapper>
              {summaryGroupFields.map((summaryGroupField, idx) => {
                const {
                  fields: { name: fieldName, label: fieldLabel }
                } = summaryGroupField;
                const summaryGroupFieldKey = `summaryGroupField${idx}`;

                return (
                  <div key={summaryGroupFieldKey}>
                    <span style={{ fontWeight: '400' }}>{fieldLabel}</span>:{' '}
                    {formFields[fieldName].value}
                  </div>
                );
              })}
            </SummaryGroupWrapper>
          </Fragment>
        );
      });
    }

    return Object.keys(formFields).map((item, index) => {
      const key = `summary${index}`;

      return (
        formFields[item].isVisible && (
          <div key={key}>
            <span style={{ fontWeight: '400' }}>{item}</span>:{' '}
            {formFields[item].value}
          </div>
        )
      );
    });
  };

  if (isLoading) return null;

  return (
    <div ref={formStepRef} style={{ width: '100%' }}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          formName={formName}
        />
      )}
      {isMultisiteOrder && (
        <div style={{ padding: '0.5rem 1.5rem', backgroundColor: '#4b286d' }}>
          <h3 style={{ fontSize: '1.75rem', fontWeight: '500', color: '#fff' }}>
            {isLastStep ? multisiteSummaryLabel : `${siteLabel} ${currentSite}`}
          </h3>
        </div>
      )}
      <div style={{ backgroundColor: '#fff' }}>
        <form
          name={formStepName}
          onSubmit={e => e.preventDefault()}
          encType="multipart/form-data"
        >
          <Box
            style={{
              border: '1px solid #e3e3e3',
              boxShadow: '1px 1px 9px 4px #e3e3e3',
              padding: '2rem',
              marginBottom: '1rem'
            }}
          >
            {sections.length ? (
              <div className="expand">
                <ExpandCollapse tag="h2" topDivider={false} open={open}>
                  {isMultisiteOrder && isLastStep
                    ? multiSiteOrderSummaryData &&
                      renderMultiSiteSummary(formStepFields)
                    : renderFormFields(formStepFields)}
                </ExpandCollapse>
              </div>
            ) : (
              <div style={{ width: '100%' }}>
                {formStepFields ? (
                  renderFormFields(formStepFields)
                ) : (
                  <>
                    <h3 style={{ marginBottom: '1em' }}>{summaryLabel}</h3>
                    {getSummary()}
                  </>
                )}
              </div>
            )}
          </Box>
        </form>
        {(![1, 2, 3].includes(step) || showFormButtons) && (
          <>
            {isMultisiteOrder ? (
              <FormButtonsMultisite
                isFormTouched={isFormTouched}
                showSave={!isOrderFulfillmentTeam && onSaveAndExit}
                orderData={orderData}
                isSalesSupport={isSalesSupport}
                isLastStep={isLastStep}
                isSecondLastStep={isSecondLastStep}
                nextStep={nextStep}
                prevStep={prevStep}
                saveAndExit={saveAndExit}
                currentSite={currentSite}
                totalNumberOfMultisites={totalNumberOfMultisites}
              />
            ) : (
              <FormButtons
                isFormTouched={isFormTouched}
                showSave={!isOrderFulfillmentTeam && onSaveAndExit}
                orderData={orderData}
                isSalesSupport={isSalesSupport}
                isLastStep={isLastStep}
                isSecondLastStep={isSecondLastStep}
                nextStep={nextStep}
                prevStep={prevStep}
                saveAndExit={saveAndExit}
                formName={formName}
              />
            )}
          </>
        )}
      </div>
      {formName === businessConnectQuoteToolForm && (
        <div
          className="container 85%"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {!isOrderFulfillmentTeam && !isProposalHouse && !isSalesManager && (
            <button
              type="button"
              onClick={nextStep}
              className={`frg-button ${
                prequalEligibility.isEligible ? 'color-green' : 'state-disabled'
              }`}
              style={{ marginBottom: '1em' }}
            >
              {newOrderButtonLabel}
            </button>
          )}
        </div>
      )}
      {formName === orderDetailsForm && step === 1 && (
        <StatusBar
          isSendToSRT={isSendToSRT}
          isVBP={isVBP}
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          isOrderFulfillmentTeam={isOrderFulfillmentTeam}
          isSalesSupport={isSalesSupport}
          dueMonthly={dueMonthly}
          dueNow={dueNow}
          onSaveAndExit={saveAndExit}
          onDownloadClick={onViewPdf}
          onProceedClick={nextStep}
          onValidateForm={validateForm}
          onSendToSRT={onSendToSRT}
          onSubmitForApproval={onSubmitForApproval}
          hidePricing={
            getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon
          }
          statusQuote={_.get(orderData, 'quoteStatus', '')}
          isFieldReset={isFieldReset}
        />
      )}
      {
        <Modal
          heading={modalData.title}
          bodyText={modalData.body}
          confirmCTAText={modalData.confirmText}
          cancelCTAText={modalData.cancelText}
          onConfirm={() =>
            history.push({
              pathname: '/'
            })
          }
          onClose={() => setModalData({ ...modalData, open: false })}
          isOpen={modalData.open}
          focusElementAfterClose={formStepRef}
        />
      }
    </div>
  );
};

FormStep.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.objectOf(PropTypes.object).isRequired
  }).isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setEligible: PropTypes.func,
  eligible: PropTypes.objectOf(PropTypes.any).isRequired,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.objectOf(PropTypes.any),
  hideProgressBar: PropTypes.bool,
  setOrderData: PropTypes.func,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  onSave: PropTypes.func,
  onViewPdf: PropTypes.func,
  sendToSRT: PropTypes.func,
  submitForApproval: PropTypes.func,
  prevStep: PropTypes.func.isRequired,
  showFormButtons: PropTypes.bool,
  currentSite: PropTypes.number.isRequired,
  isMultisiteOrder: PropTypes.bool.isRequired,
  totalNumberOfMultisites: PropTypes.number.isRequired
};

FormStep.defaultProps = {
  updateStep: () => {},
  setEligible: null,
  onFormSubmit: null,
  orderData: {},
  onSaveAndExit: null,
  hideProgressBar: false,
  setOrderData: () => {},
  onSave: null,
  onViewPdf: null,
  sendToSRT: null,
  submitForApproval: null,
  showFormButtons: null
};

export default FormStep;
